import React, { useEffect, useState } from "react";

import {
    Button,
    Col,
    FormLabel,
    Row,
    Table,
    FormControl,
} from "react-bootstrap";
import { AppContext } from "../AppContext.js";
import { BaseInquiryToolBar, BaseNodeBar, BaseToolBar, ModuleToolBar, } from "./BaseModule.js";
import { BaseBean, NodeData, RestReportBean } from "../ds/client_ds.js";
import { SecurityAccessManager } from "../security/SecurityAccessManager.js";
import { DeleteIcon } from "../gui_components/Icons.js";
import {
    AlertToolBox,
    ColumnDefinition,
    DatePickerComponent,
    DatePickerComponent_adv,
    InputTextbox,
    MultiViewPopup,
    ProgressBar,
    ShowError,
    InputCheckbox,
    NumberFormatInputbox,
    ReasonCaptureComponent,
} from "../gui_components/UIComponents.js";
import {
    isEmpty,
    isEmptyArray,
    isEmptyString,
    toFormattedDate_v1
} from "../gui_components/Util.js";
import {
    NEW_ENTRY,
} from "../ds/App_Constants.js";
import {
    RestReadRequest,
    DebitMemoBean, RestPageListBean, PurchaseOrderSearchCriteria, RestPurchaseOrderListRequest, SKUBatchInventorySearchCriteria, RestSalesOrderListRequest, PageListBean, PickTicketSearchCriteria,
    RestDebitMemoBeanRequest, FabricStyleSearchCriteria, RestFabricStyleListBeanRequest, RestSkuBatchInventoryListRequest, LogisticOrderReceiptSearchCriteria,
    RestEntityUnLockRequest, DebitMemoSearchCriteria, RestPurchaseOrderReceiptListRequest, PurchaseOrderReceiptSearchCriteria, DebitMemoReturnLineBean, CriticalPathManagementLineBean, ReasonBean, VendorSearchCriteria, RestVendorListRequest
} from "../ds/ds.js";
import { VendorService } from "../services/VendorService.js";
import { VendorLookupHandler } from "../lookup/VendorLookupHandler.js";
import { DebitMemoLookupHandler } from "../lookup/DebitMemoLookupHandler.js";
import { PurchaseOrderLookupHandler } from "../lookup/PurchaseOrderLookupHandler.js";
import { PurchaseOrderService } from "../services/PurchaseOrderService.js";
import { ConfigManager } from "../config/ConfigManager.js";
import { GenericAttributeLookupHandler } from "../lookup/GenericAttributeLookupHandler.js";
import { DebitMemoService } from "../services/DebitMemoService.js";
import { ModuleUtils } from "./ModuleUtils.js";
import { LogicConstants } from "../ds/LogicConstants.js";
import CustomTable from "../gui_components/CustomTable.js";
import { FabricStyleLookupHandler } from "../lookup/FabricStyleLookupHandler.js";
import { FabricStyleService } from "../services/FabricStyleService.js";
import { InventoryService } from "../services/InventoryService.js";
import { PurchaseOrderReceiptService } from "../services/PurchaseOrderReceiptService.js";
import { PurchaseOrderReceiptLookupHandler } from "../lookup/PurchaseOrderReceiptLookupHandler.js";
import { RollSkuLookupHandler } from "../lookup/RollSkuLookupHandler.js";
class DebitMemo extends React.Component {
    static contextType = AppContext;
    constructor(props) {
        super(props);
        this.cancelReasonDialogRef = React.createRef();
        this.state = {
            pageTitle: "DEBIT MEMO MAINTENANCE",
            isLoading: false,
            debitMemoDataBean: new DebitMemoBean(),
            progressLoadingText: "",
            isShowProgressBarPopup: false,
            alertMessage: [],
            alertType: "",
            isShowAlert: false,
            error_list: [],
            isSpecialViewMode: false,

            debitMemoSearchCriteria: new DebitMemoSearchCriteria(),

            isViewMode: false,
            isResetView: true,

            isShowModuleSearchContainer: false,
            isMaintenanceMode: true,
            moduleKeyCode: "NEW",
            debitMemoLookHandler: null,
            isFocusLookup: true,
            isDebitMemoEntryFormOpen: false,
            isDebitMemoAppliedFormOpen: false,
            isDebitMemoListFormOpen: false,
            isShowNodes: false,
            isShowReturnNodes: false,
            nodeList: [],
            selectedNodeKey: "headerView",
            isShowAutoCompleteVendorList: false,
            vendorPageListForAutoCompleteList: new Array(),
            isShowPOLookup: false,
            isShowAutoCompletePoList: false,
            poPageListForAutoCompleteList: new Array(),

            isShowBackButton: false,
            isShowSaveButton: false,
            isShowClearErrorButton: false,

            debitMemoType: [],
            moduleOrderStatus: "",
            pageList: new PageListBean(),
            debitMemoList: [],


            isShowCancelButton: false,
            isShowApproveButton: false,

            reasonData: new ReasonBean(),
            cancelReasons: [],
            // cancelReasons: [],
            isShowCancelReasonPopup: false,
            showAutoCompleteReasonList: false,
            reasonPageListForAutoCompleteList: new Array(),
            isDebitMemoHistoryFormOpen: false,

            isDisableFields: false,
            purchaseorderLookupHandler: null,
            debitMemoList: [],
            isDebitReturnype: false,


            debitMemoReturnLineData: new DebitMemoReturnLineBean(),
            showAutoCompleteFabricList: false,
            fabricPageListForAutoCompleteList: new Array(),


            isShowColorLookup: false,
            colorLookupHandler: null,
            fabricColourPageListForAutoCompleteList: new Array(),
            fabricPageListForAutoCompleteList: new Array(),
            showAutoCompleteFabricColorList: true,
            is3PL: false,

            isShowMultipleReturnPopup: false,

            purchaseReceiptLookupHandlerMulti: null,
            showAutoCompletepurchaseReceiptList: false,
            purchaseReceiptPageListForAutoCompleteList: new Array(),


            returnNodeList: [],


            isShowAutoCompleteReturnPoList: false,
            poPageListForReturnAutoCompleteList: new Array(),

            isShowPurchaseReceiptLookup: false,
            rollSkuLookupHandler: null,
            rollSkuList: [],

            lookup_data: [],
        }

    }
    isLocked = false;
    code = NEW_ENTRY;

    componentDidMount() {
        const { appData } = this.context;
        this.companyCode = appData.companyCode;
        const { cache } = appData;
        this.cache = cache;
        if (ConfigManager.isPurchaseBasedOnCustomerFlag()) {
            this.state.is3PL = true;
            this.setState({
                is3PL: true,
            });
        }
        const attribute_cache = { ...this.cache };
        this.moduleCaption = "DEBIT MEMO MAINTENANCE";
        if (ConfigManager.getDebitMemoType()) {
            let debitMemoType = ConfigManager.getDebitMemoType();

            let arr = debitMemoType.split(","); // Splitting by comma
            let debitMemoMode = [];
            arr.map((type) => {
                let typeBean = new BaseBean();
                typeBean.code = type;
                typeBean.description = "DebitMemoType";
                debitMemoMode.push(typeBean);
            })
            this.setState({ debitMemoType: debitMemoMode }, () => {

            });
        }
        let cancelReasons = attribute_cache.creditReasons;
        if (cancelReasons != null || cancelReasons != undefined) {
            cancelReasons.map((attr) => {
                this.state.cancelReasons.push(attr);
            });
        }
        this.state.debitMemoSearchCriteria = new DebitMemoSearchCriteria();
        this.state.debitMemoSearchCriteria.companyCode = this.companyCode;
        this.state.pageList = new PageListBean();
        this.state.pageList.pageSize = 50;
        ModuleUtils.getDebitMemoStatusList();
        ModuleUtils.getDebitMemoLinesStatusList();
        ModuleUtils.getDebitMemoTrackStatusList();
        this.initLookupHandlers();
        let isReadOnly = this.state.isReadOnlyOrDisabled;
        let isSpecialViewMode = this.state.isSpecialViewMode;
        if (this.props.isSpecialViewMode) {
            isSpecialViewMode = this.props.isSpecialViewMode;
            isReadOnly = this.props.isSpecialViewMode;
        }
        this.setState({
            isReadOnlyOrDisabled: isReadOnly,
            isSpecialViewMode: isSpecialViewMode,
        });
        if (this.props.code !== "" && this.props.code !== undefined) {

            this.code = this.props.code;
            this.editDebitMemo(this.props.code);

            this.setState({
                isResetView: false,
                isMaintenanceMode: false,
                isDisabledFields: true,
                disableSalesOrderFormFields: true,
                isViewMode: false,
            });
        } else {
            this.addNewEntry();
        }

    }
    getEmptyView() {
        return <div></div>;
    }

    getReturnNode = () => {
        let returnNodeList = [];
        //   let adjustData = this.state.inventoryAdjustmentData;
        let headerObject = this.getEmptyView();
        let purchaseReceiptObject = this.getEmptyView();
        let headerNode = new NodeData("headerView", "General", headerObject);
        let purchaseReceiptNode = new NodeData("purchaseReceiptView", "PurchaseReceiptBased", purchaseReceiptObject);
        returnNodeList["headerView"] = headerNode;
        returnNodeList["purchaseReceiptView"] = purchaseReceiptNode;
        this.setState({ returnNodeList: returnNodeList });
    }

    nodeOnReturnSelect = (selectedReturnNodeKey) => {
        if (selectedReturnNodeKey == "headerView") {
            this.setHeaderViewButtons();
        } else if (selectedReturnNodeKey == "purchaseReceiptView") {
            this.setReturnReceiptButtons();
        }
        this.setState({ selectedReturnNodeKey: selectedReturnNodeKey });
    };

    setHeaderViewButtons = () => {
        this.clearReturnLineValues();
        this.setState({
            isShowGeneralTab: true,
            isShowPurchaseReceiptTab: false,
        });
    };

    setReturnReceiptButtons = () => {
        this.clearReturnLineValues();
        this.setState({
            isShowPurchaseReceiptTab: true,
            isShowGeneralTab: false,
        });
    }
    initLookupHandlers = () => {
        let debitMemoLookHandler = new DebitMemoLookupHandler(
            this.companyCode,
            "DebitMemo"
        );
        this.setState({ debitMemoLookHandler: debitMemoLookHandler });


        let purchaseReceiptLookupHandler = new PurchaseOrderReceiptLookupHandler(
            this.companyCode,
            "Purchase Receipt"
        );
        this.setState({
            purchaseReceiptLookupHandlerMulti: purchaseReceiptLookupHandler,
        });
    }
    hideAlertCallBack = (msgType, isDisplayed) => {
        this.setState({
            isShowAlert: isDisplayed,
        });
    };

    addNewEntry = () => {
        let debitMemoBean = new DebitMemoBean();
        debitMemoBean.companyCode = this.companyCode;
        debitMemoBean.code = NEW_ENTRY;
        let pageTitle = this.moduleCaption + " - NEW";
        debitMemoBean.createdDate = toFormattedDate_v1(new Date());
        debitMemoBean.debitMemoStatus = LogicConstants.DEBIT_MEMO_OPEN_STATUS;


        this.setState({
            debitMemoDataBean: debitMemoBean,
            isDebitMemoListFormOpen: false,
            pageTitle: pageTitle,
            isLoading: false,
            isDebitReturnype: false,

        });

        this.openEntryForm();
    };
    openEntryForm = () => {
        this.closeAllNodeViews();
        this.getNodeList();
        this.setState({
            isDebitMemoEntryFormOpen: true,
            isDebitMemoListFormOpen: false,
            isShowSaveButton: true,
            isShowClearCriteriaButton: false,
            isShowClearErrorButton: true,
            isShowUnApproveButton: false,
            // isShowApproveButton: false,
            isShowCancelButton: false,
            isShowNodes: true,
            isResetView: false,
            isShowModuleSearchContainer: true,
            isShowApproveButton: true,
            isShowCancelButton: false,
            //  isDisabledFields: false,
        });
        if (this.state.isSpecialViewMode == false) {
            this.setState({
                isResetView: true,
                isMaintenanceMode: true,
                disabled: false,
            });

        } else {
            this.setState({
                isDisableFields: true,
                disabled: true,
            });
        }
        if (this.state.moduleKeyCode != NEW_ENTRY) {
            this.setState({ disabled: true });
        }
        let debitMemoDataBean = this.state.debitMemoDataBean;
        let moduleOrderStatus = this.state.moduleOrderStatus;
        let debitMemoStatus = ModuleUtils.getDebitMemoStatusCaption(
            this.state.moduleOrderStatus.debitMemoStatus
        );
        if (debitMemoStatus !== undefined && debitMemoStatus !== null) {
            moduleOrderStatus = debitMemoStatus;
        }
        this.setState({ moduleOrderStatus: moduleOrderStatus });

        if (debitMemoDataBean.isFetched) {
            if (
                debitMemoDataBean.debitMemoStatus ==
                LogicConstants.DEBIT_MEMO_OPEN_STATUS
            ) {
                this.setState({
                    //isShowUnApproveButton: false,
                    isShowCancelButton: true,
                    isShowApproveButton: true,
                    isShowSaveButton: true,
                    //   disableFormFields: true,
                    //   isShowExcelButton: true,
                    //   isShowPDFReportButton: true,
                    //   isShowPORButton: false,
                    //   isDisableButtons: false,
                    //   isShowCreateInvoiceButton: true,
                    //   isShowInTransitLookup: false,
                    //   isDisablePoIntransit: true,
                });
            }
            if (
                debitMemoDataBean.debitMemoStatus ==
                LogicConstants.DEBIT_MEMO_APPROVE_STATUS
            ) {
                this.setState({
                    isShowUnApproveButton: false,
                    isShowCancelButton: true,
                    isShowApproveButton: false,
                    isShowSaveButton: true,
                    isShowPopup: false,
                    // disableFormFields: false,
                    // isShowExcelButton: true,
                    // isShowPDFReportButton: true,
                    // isShowPORButton: false,
                    // isDisableButtons: true,
                    // isShowCreateInvoiceButton: false,
                    // isShowInTransitLookup: true,
                    // isDisablePoIntransit: true,
                });
            }
            if (
                debitMemoDataBean.debitMemoStatus ==
                LogicConstants.DEBIT_MEMO_FINISHED_STATUS
            ) {
                this.setState({
                    isShowUnApproveButton: false,
                    isShowCancelButton: false,
                    isShowApproveButton: false,
                    isShowSaveButton: false,
                    isShowPopup: false,
                    // disableFormFields: true,
                    // isShowExcelButton: true,
                    // isShowPDFReportButton: true,
                    // isShowPORButton: false,
                    // isDisableButtons: false,
                    // isShowCreateInvoiceButton: false,
                    // isShowInTransitLookup: false,
                    // isDisablePoIntransit: true,
                });
            }
            if (
                debitMemoDataBean.debitMemoStatus ==
                LogicConstants.DEBIT_MEMO_CANCEL_STATUS
            ) {
                this.setState({
                    isShowUnApproveButton: false,
                    isShowCancelButton: false,
                    isShowApproveButton: false,
                    isShowSaveButton: false,
                    isShowPopup: false,
                    // disableFormFields: true,
                    // isShowExcelButton: true,
                    // isShowPDFReportButton: true,
                    // isShowPORButton: false,
                    // isDisableButtons: false,
                    // isShowCreateInvoiceButton: false,
                    // isShowInTransitLookup: false,
                    // isDisablePoIntransit: true,
                });
            }
            //   if (!purchaseOrderReceiptData.isFetched) {
            //     this.setState({
            //       isDisableButtons: true,
            //       isShowUnApproveButton: false,
            //       disableFormFields: true,
            //       isShowPORButton: false,
            //       isShowAutoCompletePurchaseOrderList: false,
            //       purchaseOrderPageListForAutoCompleteList: new Array(),
            //       isShowAutoCompleteRolllineLocationList: false,
            //       rollLineLocationPageListForAutoCompleteList: new Array(),
            //       isShowAutoCompleteLocationList: false,
            //       locationPageListForAutoCompleteList: new Array(),
            //       isShowAutoCompleteFobCityList: false,
            //       FobCityPageListForAutoCompleteList: new Array(),
            //       isShowAutoCompleteShipmentTermList: false,
            //       shipmentTermPageListForAutoCompleteList: new Array(),
            //       isShowAutoCompleteShipViaList: false,
            //       shipViaPageListForAutoCompleteList: new Array(),
            //       isShowAutoCompletePoIntransitList: false,
            //       poIntransitPageListForAutoCompleteList: new Array(),
            //       isShowCreateInvoiceButton: false,
            //       isShowInTransitLookup: true,
            //     });
            //   }
        }

        if (this.state.isViewMode) {
            let pageTitle = this.moduleCaption + " - VIEW";
            this.setState({
                isDisabledFields: true,
                disabled: true,
                pageTitle: pageTitle,
            });
        }
    }
    getEmptyView() {
        return <div></div>;
    }
    getNodeList = () => {
        let nodeList = [];
        let debitMemoDataBean = this.state.debitMemoDataBean;
        let emptyObject = this.getEmptyView();
        let headerNode = new NodeData("headerView", "Header", emptyObject);
        let appliedTransactionNode = new NodeData(
            "appliedTransactionView",
            "AppliedTransaction",
            emptyObject
        );
        let historyNode = new NodeData(
            "historyView",
            "History",
            emptyObject
        );

        nodeList["headerView"] = headerNode;
        // nodeList["appliedTransactionView"] = appliedTransactionNode;
        if (debitMemoDataBean.isFetched) {
            nodeList["historyView"] = historyNode;
        }

        this.setState({ nodeList: nodeList });

    }

    nodeOnSelect = (selectedNode) => {
        this.setState({ selectedNodeKey: selectedNode });
        if (selectedNode == "headerView") {
            this.setDebitMemoHeaderView();
        } else if (selectedNode == "appliedTransactionView") {
            this.setDebitMemoAppliedTransactionView();
        } else if (selectedNode == "historyView") {
            this.setDebitMemoHistoryView();
        }
    };
    setDebitMemoHeaderView = () => {
        this.closeAllNodeViews();
        this.setState({
            isShowBackButton: false,
            isDebitMemoEntryFormOpen: true,
        });
    }


    setDebitMemoAppliedTransactionView = () => {
        this.closeAllNodeViews();
        this.setState({
            isShowBackButton: false,
            isDebitMemoAppliedFormOpen: true,
        });
    }
    setDebitMemoHistoryView = () => {
        this.closeAllNodeViews();
        this.setState({
            isShowBackButton: false,
            isDebitMemoHistoryFormOpen: true,
        });
    }
    closeAllNodeViews = () => {
        this.setState({
            isDebitMemoListFormOpen: false,
            isDebitMemoEntryFormOpen: false,
            isDebitMemoAppliedFormOpen: false,
            isDebitMemoHistoryFormOpen: false,
        });
    }
    unlockDebitMemo = (code) => {
        let debitMemoDataBean = this.state.debitMemoDataBean;
        let data = new RestEntityUnLockRequest();
        data.companyCode = this.companyCode;
        data.entityCode = code;
        // if (code != NEW_ENTRY) {
        if (SecurityAccessManager.SalesOrderMaintenance_IsAccessible()) {
            DebitMemoService.unLockDebitMemoNumber(
                data,
                this.unLockDebitMemoNumberResponse,
                this.errorCallBack
            );
        } else {
            let errMsg = "Access Denied";
            let errList = [];
            errList.push(errMsg);

            this.setState({
                alertMessage: errList,
                alertType: "danger",
                isShowAlert: true,
            });
        }

    }
    unLockDebitMemoNumberResponse = (response) => {
        if (!isEmpty(response.data)) {
            if (response.data.isSuccess) {
                if (this.isLocked) {
                    this.editDebitMemo(this.code);
                } else {
                    this.isLocked = false;
                }
                // this.isLocked = false;
            } else {
                // this.isLocked = true;
                // this.isLocked = false; optional
                if (!this.state.isReseted) this.showErrorMessage(response.data);
            }
        }
    }
    moduleExit = () => {
        let debitMemoDataBean = this.state.debitMemoDataBean;
        if (debitMemoDataBean.code === NEW_ENTRY) {
            this.props.onModuleExit();
        } else {
            if (!this.state.isViewMode && this.isLocked)
                this.unlockDebitMemo(debitMemoDataBean.code);
            this.props.onModuleExit();
        }
    };
    resetView = () => {
        let debitMemoDataBean = this.state.debitMemoDataBean;
        this.state.isReseted = true;
        if (this.isLocked) {
            this.isLocked = false;
            if (!this.state.isViewMode)
                this.unlockDebitMemo(debitMemoDataBean.code);
        } else {
            this.isLocked = false;
        }
        this.setState({
            debitMemoDataBean: debitMemoDataBean,
            isShowModuleSearchContainer: true,
            // isDisabledFields: false,
            moduleKeyCode: "NEW",
            // isFocusLookup: true,
            isDebitMemoEntryFormOpen: true,
            isDebitMemoListFormOpen: false,
            isDebitMemoAppliedFormOpen: false,
            isDebitMemoHistoryFormOpen: false,
            selectedNodeKey: "headerView",
            isDisableFields: false,
            isShowPOLookup: false,
            // isShowSaveButton: true,
            // isShowClearCriteriaButton: false,
            // isShowClearErrorButton: true,
            // previousValue: "",
            isDebitReturnype: false,

        })
        this.state.isViewMode = false;
        this.code = NEW_ENTRY;
        this.state.isViewMode = false;
        this.hideAlertCallBack();
        this.addNewEntry();

    }
    editDebitMemo = (debitMemoCode) => {
        let readrestInput = new RestReadRequest();
        readrestInput.companyCode = this.companyCode;
        readrestInput.code = debitMemoCode;
        // let isLockRequired = NEW_ENTRY === salesOrderCode ? false : true;
        let isLockRequired = false;
        if (this.props.isSpecialViewMode) {
            isLockRequired = false;
        } else {
            isLockRequired = NEW_ENTRY === debitMemoCode ? false : true;
        }
        readrestInput.isLockRequired = isLockRequired;

        if (SecurityAccessManager.DebitMemoMaintenanceView_IsAccessible()) {
            DebitMemoService.initDebitMemoModule(
                readrestInput,
                this.editDebitMemoResponse,
                this.errorCallBack
            );
        } else {
            let errMsg = "Access Denied";
            let errList = [];
            errList.push(errMsg);
            this.setState({
                alertMessage: errList,
                alertType: "danger",
                isShowAlert: true,
            });
        }
    }
    showErrorMessage = (response) => {
        if (response.errors != null) {
            let errMsg = "";
            let errList = this.state.error_list;
            response.errors.map(
                (err) => (
                    (errMsg = errMsg + err.messageDescription),
                    errList.push(err.messageDescription)
                )
            );
            this.setState({ error_list: errList });
            this.setState({
                alertMessage: errList,
                alertType: "danger",
                isShowAlert: true,
            });
        }
    };
    showInfoMessage = (response) => {
        if (response.infos != null) {
            let infoMsg = "";
            let successList = [];
            response.infos.map(
                (info) => (
                    (infoMsg = infoMsg + info.messageDescription),
                    successList.push(info.messageDescription)
                )
            );
            this.setState({
                alertMessage: successList,
                alertType: "success",
                isShowAlert: true,
            });
        }
    };
    editDebitMemoResponse = (response) => {

        let errMsg = "";
        if (response.data.lockResponse != null) {
            if (!isEmpty(response.data.lockResponse.errors)) {
                this.showErrorMessage(response.data.lockResponse);
                this.state.isViewMode = true;
            }
        }
        if (response.data.debitMemoResponse != null) {
            if (response.data.debitMemoResponse.errors != null) {
                response.data.debitMemoResponse.errors.map((err) => {
                    errMsg = err.messageDescription;
                });
            }
        }
        if (response.data.debitMemoResponse != null) {
            if (
                errMsg !=
                "Debit Memo [" + this.state.moduleKeyCode + "] Not read!"
            ) {
                this.showErrorMessage(response.data.debitMemoResponse);
            }
        }
        if (response.data.debitMemoResponse != null) {
            if (
                response.data.debitMemoResponse.debitMemo != null
            ) {
                let debitMemoDataBean =
                    response.data.debitMemoResponse.debitMemo;
                let pageTitle = this.moduleCaption + " - EDIT";
                let moduleKeyCode = debitMemoDataBean.code;
                let isDebitReturnype = false;
                if (debitMemoDataBean.debitMemoType == "RETURN") {
                    isDebitReturnype = true;
                    // this.setState({
                    //     isDebitReturnype: true,
                    //     isCheckType: false,
                    //     isWireType: false,
                    //     isCreditType: false,

                    // });
                }
                let isDisableFields = true;
                this.setState({
                    debitMemoDataBean: debitMemoDataBean,
                    pageTitle: pageTitle,
                    //   isFocusLookup: false,
                    //   isFocus: true,
                    moduleKeyCode: moduleKeyCode,
                    isLoading: false,
                    selectedNodeKey: "headerView",
                    isDisableFields: isDisableFields,
                    isDebitReturnype: isDebitReturnype,
                },
                    () => {

                        this.openEntryForm();
                    }
                );
                this.isLocked = true;
                // //this.getNodeList();
                // this.openEntryForm();
            } else {
                this.addNewEntry();
            }
        }
        this.setState({ isLoading: false });

    }

    selectButtonClick = (e) => {
        this.editDebitMemo(this.state.moduleKeyCode);
    };
    onModuleKeyCodeChange = (e) => {
        let moduleKeyCode = this.state.moduleKeyCode;
        if (e.target.value !== NEW_ENTRY && e.target.value !== "undefined") {
            moduleKeyCode = e.target.value;
        }
        this.setState({ moduleKeyCode: moduleKeyCode });
    };
    onModuleKeyCodeWithCriteriaOnChange = (e) => {
        let moduleKeyCode = this.state.moduleKeyCode;
        if (e.target.value !== NEW_ENTRY && e.target.value !== "undefined") {
            moduleKeyCode = e.target.value.toUpperCase();
        }
        this.setState({ moduleKeyCode: moduleKeyCode });
    };
    closeEntryForm = () => {
        this.setState({
            isShowModuleSearchContainer: false,
            moduleKeyCode: "NEW",
            isFocusLookup: true,
            isDebitMemoEntryFormOpen: false,
            isDebitMemoListFormOpen: true,
            isDebitMemoAppliedFormOpen: false,
            isDebitMemoHistoryFormOpen: false,
            isMaintenanceMode: false,
            isViewMode: false,
            isSpecialViewMode: false,
            isResetView: false,
            isShowNodes: false,
            isShowSaveButton: false,
            isShowClearCriteriaButton: false,
            isShowClearErrorButton: false,
            isShowBackButton: false,
            moduleOrderStatus: "",
            isShowUnApproveButton: false,
            //   isShowApproveButton: false,
            isShowCancelButton: false,
            isDisableFields: false,
            isDebitReturnype: false,
        })
    };
    getModuleListView = () => {

        let debitMemoDataBean = this.state.debitMemoDataBean;
        if (debitMemoDataBean.code === NEW_ENTRY) {
            this.closeEntryForm();
            this.loadDebitMemoPage();
        } else {
            if (this.isLocked) {
                this.isLocked = false;
                if (!this.state.isViewMode) this.unlockDebitMemo(debitMemoDataBean.code);
            } else {
                this.isLocked = false;
            }
            this.closeEntryForm();
            this.loadDebitMemoPage();
        }


    };
    loadDebitMemoPage = () => {
        let requestInput = new RestDebitMemoBeanRequest();
        requestInput.pageInput = this.state.pageList;
        requestInput.searchCriteria = this.state.debitMemoSearchCriteria;
        this.setState({
            isLoading: true,
            loadingText: "Loading ..",
        });
        if (SecurityAccessManager.DebitMemoMaintenanceView_IsAccessible()) {
            DebitMemoService.getDebitMemoPageList(
                requestInput,
                this.loadDebitMemoPageResponse,
                this.errorCallBack
            );
        } else {
            let errMsg = "Access Denied";
            let errList = [];
            errList.push(errMsg);

            this.setState({
                alertMessage: errList,
                alertType: "danger",
                isShowAlert: true,
            });
        }
        // this.setState({
        //     // isDebitMemoEntryFormOpen: true,
        //     isDebitMemoListFormOpen: true,
        //     isResetView: false,
        //     isShowModuleSearchContainer: false,
        // });
    }


    loadDebitMemoPageResponse = (response) => {
        let debitMemoList = new Array();
        if (
            !isEmpty(response.data) &&
            !isEmpty(response.data.debitMemoPageList)
        ) {
            debitMemoList = response.data.debitMemoPageList.debitMemos;
            this.state.pageList.totalCount =
                response.data.debitMemoPageList.totalCount;
            this.state.pageList.currentPage =
                response.data.debitMemoPageList.currentPage;
        } else {
            debitMemoList = new Array();
        }
        let loading = this.state.isLoading;
        let pageTitle = this.moduleCaption;
        loading = false;
        this.setState({
            isLoading: loading,
            debitMemoList: debitMemoList,
            pageTitle: pageTitle,
        });
    };


    getHeaderView() {
        return (
            <DebitMemoEntryForm
                {...this.state}
                vendorCodeOnChange={this.vendorCodeOnChange}
                vendorCodeEnterKeyEventHandler={this.vendorCodeEnterKeyEventHandler}
                displayVendorAutoCompleteList={this.displayVendorAutoCompleteList}
                onChange={this.onChange}
                purchaseOrderOnChange={this.purchaseOrderOnChange}
                poEnterKeyEventHandler={this.poEnterKeyEventHandler}
                displayPoAutoCompleteList={this.displayPoAutoCompleteList}


                onDebitMemoTypeChange={this.onDebitMemoTypeChange}
                debitMemoTypeEnterKeyEvent={this.debitMemoTypeEnterKeyEvent}
                displayAutoCompleteDebitMemoTypeList={this.displayAutoCompleteDebitMemoTypeList}
                onLineChange={this.onLineChange}


                fabricCodeOnChange={this.fabricCodeOnChange}
                fabricEnterKeyEventHandler={this.fabricEnterKeyEventHandler}
                displayAutoCompleteFabricList={this.displayAutoCompleteFabricList}


                onFabricColourCodeChange={this.onFabricColourCodeChange}
                fabricColourEnterKeyEventHandler={this.fabricColourEnterKeyEventHandler}
                displayAutoCompleteFabricColorList={this.displayAutoCompleteFabricColorList}


                rollSkuNumberOnChange={this.rollSkuNumberOnChange}


                addOrUpdateReturnLineChange={this.addOrUpdateReturnLineChange}
                clearReturnLineValues={this.clearReturnLineValues}
                deleteReturnLine={this.deleteReturnLine}
                handleLineNumberClick={this.handleLineNumberClick}


                mutipleReturnLines={this.mutipleReturnLines}

                nodeOnSelect={this.nodeOnSelect}

                nodeOnReturnSelect={this.nodeOnReturnSelect}


                purchaseOrderReturnOnChange={this.purchaseOrderReturnOnChange}
                poReturnEnterKeyEventHandler={this.poReturnEnterKeyEventHandler}
                displayPoAutoCompleteReturnList={this.displayPoAutoCompleteReturnList}

                onPurchaseReceiptChange={this.onPurchaseReceiptChange}
                purchaseReceiptEnterKeyEventHandler={this.purchaseReceiptEnterKeyEventHandler}
                displayAutoCompletepurchaseReceiptList={this.displayAutoCompletepurchaseReceiptList}


                onRollSkuChange={this.onRollSkuChange}
                rollSKuEnterKeyEventHandler={this.rollSKuEnterKeyEventHandler}
                displayAutoCompleteRollSkuList={this.displayAutoCompleteRollSkuList}
            />
        )
    }
    getListView = () => {
        return (
            <DebitMemoListForm
                {...this.state}
                filterDebitMemo={this.filterDebitMemo}
                loadFirst={this.loadFirst}
                loadNext={this.loadNext}
                loadPrevious={this.loadPrevious}
                loadLast={this.loadLast}
                editDebitMemo={this.editDebitMemo}
                resetDebitMemo={this.resetDebitMemo}
                searchOnChange={this.searchOnChange}
            />
        )
    }
    getAppliedTransactionView = () => {
        return (
            <DebitMemoAppliedForm
                {...this.state}
            />
        )
    }


    getHistoryView = () => {
        return (
            <DebitMemoHistoryForm
                {...this.state}
            />
        )
    }

    //

    vendorCodeOnChange = (e) => {
        let vendorCode = e.target.value;
        this.state.isShowAutoCompleteVendorList = true;
        let tempData = this.state.debitMemoDataBean;
        let showAutoCompleteList = this.state.isShowAutoCompleteVendorList;
        if (isEmpty(vendorCode)) {
            this.state.isShowAutoCompleteVendorList = false;
            let showAutoCompleteList = this.state.isShowAutoCompleteVendorList;
            let tempData = this.state.debitMemoDataBean;
            tempData.vendorCode = "";
            tempData.vendorName = "";
            tempData.purchaseOrderNumber = "";
            let suggestion = [];
            this.setState({
                isShowAutoCompleteVendorList: showAutoCompleteList,
                debitMemoDataBean: tempData,
                vendorPageListForAutoCompleteList: suggestion,
                isShowPOLookup: false,
            });
        } else if (
            e.target.name == "vendorCode" &&
            showAutoCompleteList === true &&
            vendorCode !== ""
        ) {
            this.readVendorBySearchString(e.target.value);
        }
        tempData[e.target.name] = e.target.value.toUpperCase();
        this.setState({
            debitMemoDataBean: tempData,
        });
    };
    vendorCodeEnterKeyEventHandler = (e) => {
        this.setState({
            isShowProgressBarPopup: true,
            progressLoadingText: "Reading Vendor",
        });
        this.readVendor(e.target.value);
        this.state.isShowAutoCompleteVendorList = false;
        let showAutoCompleteList = this.state.isShowAutoCompleteVendorList;
        this.setState({
            vendorPageListForAutoCompleteList: new Array(),
            isShowAutoCompleteVendorList: showAutoCompleteList,
        });
    };
    displayVendorAutoCompleteList = (showAutoCompleteList) => {
        this.setState({ isShowAutoCompleteVendorList: showAutoCompleteList });
    };
    readVendorBySearchString(searchString) {
        let searchCriteria = new VendorSearchCriteria();
        searchCriteria.companyCode = this.companyCode;
        searchCriteria.vendorCodeStartsWith = searchString;
        searchCriteria.vendorNameContains = searchString;
        let pageList = new PageListBean();
        pageList.pageSize = 100;
        let input = new RestVendorListRequest();
        input.searchCriteria = searchCriteria;
        input.pageInput = pageList;
        VendorService.getVendorPageList(
            input,
            this.readByVendorCodeResponse,
            this.readByVendorCodeResponseError
        );
    }
    readByVendorCodeResponse = (response) => {
        let vendorCodeData = response.data.vendorPageList.vendors;
        let simpleAutoCompleteList = new Array();
        if (vendorCodeData.length > 0 && vendorCodeData != null) {
            vendorCodeData.map((vendorCode) => {
                let simpleItemBean = {
                    code: vendorCode.code,
                    description: vendorCode.description,
                };
                simpleAutoCompleteList.push(simpleItemBean);
            });
        }
        this.setState({
            vendorPageListForAutoCompleteList: simpleAutoCompleteList,
        });
    };
    readByVendorCodeResponseError = (error) => {
        ShowError("Error : ", error);
    };
    readVendor = (vendorCode) => {
        let readrestInput = new RestReadRequest();
        readrestInput.companyCode = this.companyCode;
        readrestInput.code = vendorCode;
        readrestInput.isLoadChildren = true;
        // if (SecurityAccessManager.DebitMemoMaintenance_IsAccessible()) {
        VendorService.initVendorModule(
            readrestInput,
            this.readVendorResponse,
            this.readVendorError
        );
        // } else {
        //     let errMsg = "Access Denied";
        //     let errList = [];
        //     errList.push(errMsg);
        //     this.setState({
        //         alertMessage: errList,
        //         alertType: "danger",
        //         isShowAlert: true,
        //     });
        // }
    };
    readVendorResponse = (response) => {
          if (!isEmpty(response.data) && !isEmpty(response.data.vendorResponse)
        && !isEmpty(response.data.vendorResponse.vendor)
         ) {
              let vendorData = response.data.vendorResponse.vendor;        
            let debitMemoDataBean = this.state.debitMemoDataBean;
            debitMemoDataBean.vendorCode = vendorData.code;
            debitMemoDataBean.vendorName = vendorData.description;
            let purchaseOrderLookupHandler = new PurchaseOrderLookupHandler(
                this.companyCode,
                "PurchaseOrder",
                vendorData.code
            );
            this.setState({ purchaseorderLookupHandler: purchaseOrderLookupHandler });
            this.setState({
                debitMemoDataBean: debitMemoDataBean,
                isShowPOLookup: true,
            });
       
            }
        
        this.setState({
            isShowProgressBarPopup: false,
            progressLoadingText: "",
        });
    };
    readVendorError = (error) => {
        ShowError("Error : ", error);
        this.setState({
            isShowProgressBarPopup: false,
            progressLoadingText: "",
        });
    };

    onChange = (e) => {
        let criteria = this.state.debitMemoDataBean;
        criteria[e.target.name] = e.target.value;
        this.setState({ debitMemoDataBean: criteria });
    };


    purchaseOrderOnChange = (e) => {
        let purchaseOrderNumber = e.target.value;
        this.state.isShowAutoCompletePoList = true;
        let tempData = this.state.debitMemoDataBean;
        let showAutoCompleteList = this.state.isShowAutoCompletePoList;
        if (isEmpty(purchaseOrderNumber)) {
            this.state.isShowAutoCompletePoList = false;
            let showAutoCompleteList = this.state.isShowAutoCompletePoList;
            let tempData = this.state.debitMemoDataBean;
            tempData.purchaseOrderNumber = "";


            let suggestion = [];
            this.setState({
                isShowAutoCompletePoList: showAutoCompleteList,
                debitMemoDataBean: tempData,
                poPageListForAutoCompleteList: suggestion,
                isShowPurchaseReceiptLookup: false,
            });
        } else if (
            e.target.name == "purchaseOrderNumber" &&
            showAutoCompleteList === true &&
            purchaseOrderNumber !== ""
        ) {
            this.readPOBySearchString(e.target.value);
            //  this.readPurchaseOrder(e.target.value);
        }
        tempData[e.target.name] = e.target.value.toUpperCase();
        this.setState({
            debitMemoDataBean: tempData,
        });
    };
    poEnterKeyEventHandler = (e) => {
        this.setState({
            isShowProgressBarPopup: true,
            progressLoadingText: "Reading PurchaseOrder",
        });
        this.readPurchaseOrder(e.target.value);
        this.state.isShowAutoCompletePoList = false;
        let showAutoCompleteList = this.state.isShowAutoCompletePoList;
        this.setState({
            poPageListForAutoCompleteList: new Array(),
            isShowAutoCompletePoList: showAutoCompleteList,
        });
    };
    readPOBySearchString(searchString) {
        let searchCriteria = new PurchaseOrderSearchCriteria();
        searchCriteria.companyCode = this.companyCode;
        searchCriteria.purchaseOrderNumberStartsWith = searchString;
        searchCriteria.purchaseOrderNumberContains = searchString;
        searchCriteria.vendorCode = this.state.debitMemoDataBean.vendorCode;
        searchCriteria.orderStatus = "R";
        let cust_pageList = new PageListBean();
        cust_pageList.pageSize = 100;
        let cust_requestInput = new RestPurchaseOrderListRequest();
        cust_requestInput.pageInput = cust_pageList;
        cust_requestInput.searchCriteria = searchCriteria;
        PurchaseOrderService.getPurchaseOrderPageList(
            cust_requestInput,
            this.readPurchaseOrderBySearchStringResponse,
            this.readPurchaseOrderBySearchStringError
        );
    }
    readPurchaseOrderBySearchStringResponse = (response) => {
        let purchaseorderData = response.data.purchaseOrderPageList.purchaseOrders;
        let simpleAutoCompleteList = new Array();
        if (purchaseorderData.length > 0 && purchaseorderData != null) {
            purchaseorderData.map((po) => {
                let simpleItemBean = {
                    code: po.code,
                    description: "",
                };
                simpleAutoCompleteList.push(simpleItemBean);
            });
        }
        this.setState({
            poPageListForAutoCompleteList: simpleAutoCompleteList,
        });
    };
    readPurchaseOrderBySearchStringError = (error) => {
        ShowError("Error : " + error);
    };
    displayPoAutoCompleteList = (showAutoCompleteList) => {
        this.setState({ isShowAutoCompletePoList: showAutoCompleteList });
    };

    readPurchaseOrder = (purchaseOrderCode) => {
        let readrestInput = new RestReadRequest();
        readrestInput.companyCode = this.companyCode;
        readrestInput.code = purchaseOrderCode;
        // if (SecurityAccessManager.DebitMemoMaintenance_IsAccessible()) {
        PurchaseOrderService.readPurchaseOrder(
            readrestInput,
            this.readPurchaseOrderAdvanceResponse,
            this.readPurchaseOrderAdvanceError
        );
        // } else {
        //     let errMsg = "Access Denied";
        //     let errList = [];
        //     errList.push(errMsg);

        //     this.setState({
        //         alertMessage: errList,
        //         alertType: "danger",
        //         isShowAlert: true,
        //     });
        // }
    };
    readPurchaseOrderAdvanceResponse = (response) => {
        let poBean = response.data.purchaseOrder;
        if (poBean != null) {
            let purchaseOrderData = this.state.debitMemoDataBean;
            purchaseOrderData.purchaseOrderNumber = poBean.code;
            this.setState({
                debitMemoDataBean: purchaseOrderData,
                // isShowPurchaseReceiptLookup: true,
            });
            // this.purchaseReceiptLookup(poBean.code);
        }
        this.setState({
            isShowProgressBarPopup: false,
            progressLoadingText: "",
        });
    };
    readPurchaseOrderAdvanceError = (error) => {
        ShowError("Error : ", error);
        this.setState({
            isShowProgressBarPopup: false,
            progressLoadingText: "",
        });
    };


    onDebitMemoTypeChange = (e) => {
        let debitMemoType = e.target.value;
        this.state.showAutoCompleteDebitMemoTypeList = true;
        let temp_VendorInvoicedata = this.state.debitMemoDataBean;
        let showAutoCompleteList = this.state.showAutoCompleteDebitMemoTypeList;
        if (isEmpty(debitMemoType)) {
            this.state.showAutoCompleteDebitMemoTypeList = false;
            let showAutoCompleteList = this.state.showAutoCompleteDebitMemoTypeList;
            let debitMemoType = this.state.debitMemoDataBean;
            debitMemoType.debitMemoType = "";
            this.setTransactionType(e.target.value);
            let suggestion = [];
            this.setState({
                showAutoCompleteList: showAutoCompleteList,
                debitMemoDataBean: debitMemoType,
                debitMemoTypePageListForAutoCompleteList: suggestion,
            });
        } else if (showAutoCompleteList === true && debitMemoType !== "") {
            this.readDebitMemoBySearchString(debitMemoType);
        }
        if (e.target.name == "debitMemoType") {
            temp_VendorInvoicedata["debitMemoType"] = e.target.value;
            let vendorInvoiceTypeList = this.state.debitMemoType;
            vendorInvoiceTypeList.map((pdtType) => {
                if (pdtType.code == e.target.value) {
                    temp_VendorInvoicedata["debitMemoType"] = pdtType.code;
                    this.state.showAutoCompleteDebitMemoTypeList = false;
                    let showAutoCompleteList = this.state.showAutoCompleteDebitMemoTypeList;
                    this.setState({ showAutoCompleteList: showAutoCompleteList });
                }
            });
        }
        this.setState({ debitMemoDataBean: temp_VendorInvoicedata });
    };
    readDebitMemoBySearchString(searchString) {
        let vendorInvoiceTypeList = this.state.debitMemoType;
        let simpleAutoCompleteList = new Array();
        if (vendorInvoiceTypeList.length > 0 && vendorInvoiceTypeList != null) {
            vendorInvoiceTypeList.map((uomCodeDatas) => {
                let simpleItemBean = {
                    code: uomCodeDatas.code,
                    description: uomCodeDatas.description,
                };
                simpleAutoCompleteList.push(simpleItemBean);
            });
        }
        let userInput = searchString;
        let filteredSuggestions = new Array();
        filteredSuggestions = simpleAutoCompleteList.filter(
            (simpleAutoCompleteUomCodeLists) =>
                simpleAutoCompleteUomCodeLists.code
                    .toLowerCase()
                    .indexOf(userInput.toLowerCase()) > -1
        );
        this.setState({ debitMemoTypePageListForAutoCompleteList: filteredSuggestions });
    }
    debitMemoTypeEnterKeyEvent = (e) => {
        let tempVendorInvoice_data = this.state.debitMemoDataBean;
        tempVendorInvoice_data["debitMemoType"] = e.target.value;
        let vendorInvoiceTypeList = this.state.debitMemoType;
        this.setTransactionType(e.target.value);
        let vendorInvoiceTypeBean = null;
        vendorInvoiceTypeList.map((pdtType) => {
            if (pdtType.code == e.target.value) {
                vendorInvoiceTypeBean = pdtType;
            }
        });
        if (!isEmpty(vendorInvoiceTypeBean)) {
            let tempVendorInvoice_data = this.state.debitMemoDataBean;
            tempVendorInvoice_data.debitMemoType = vendorInvoiceTypeBean.code;
            this.setState({
                debitMemoDataBean: tempVendorInvoice_data,
                debitMemoTypePageListForAutoCompleteList: new Array(),
            });
        }
    };
    displayAutoCompleteDebitMemoTypeList = (showAutoCompleteList) => {
        this.setState({ showAutoCompleteDebitMemoTypeList: showAutoCompleteList });
    };
    setTransactionType = (value) => {
        let isDebitReturnype = false;
        let debitMemoReturnLineData = new DebitMemoReturnLineBean();
        let debitMemoDataBean = this.state.debitMemoDataBean;

        debitMemoReturnLineData.companyCode = this.companyCode;
        if (value == "RETURN") {
            isDebitReturnype = true;
            debitMemoDataBean.isUpdateInventory = true;
            let lineNumber = 0;
            let lines = debitMemoDataBean.returnLines;
            lines.map((line) => {
                if (line.lineNumber > lineNumber) {
                    lineNumber = line.lineNumber;
                }
            });
            lineNumber++;
            debitMemoReturnLineData.lineNumber = lineNumber;

            if (debitMemoDataBean.isUpdateInventory == true) {
                debitMemoReturnLineData.isUpdateInventory = true;
            }

            this.getReturnNode();
        }
        this.setState({
            isDebitReturnype: isDebitReturnype,
            //   isWireType: isWireType,
            //   isCreditType: isCreditType,
            //   isWirewithLCType: isWirewithLCType,
            debitMemoReturnLineData: debitMemoReturnLineData,
            debitMemoDataBean: debitMemoDataBean,
            selectedReturnNodeKey: "headerView",
        });
    }
    save = () => {
        this.saveDebitMemo();
    };
    back = () => {
        this.closeEntryForm();
        this.loadPage(1);
    };
    loadPage = (pageNumber) => {
        let pageList = this.state.pageList;
        let pageInput = new PageListBean();
        pageInput.pageSize = 50;
        pageInput.currentPage = pageNumber;
        if (pageList != null) pageInput.totalCount = pageList.totalCount;
        this.state.pageList = pageInput;
        this.loadDebitMemoPage();
    };
    validateDebitMemo = (debitMemoBean) => {
        let isValidDebitMemoReceiptBean = false;
        let err_list = [];
        let errorMessage = "";
        if (debitMemoBean == null) {
            let errMsg = "Invalid data ";
            errorMessage = errorMessage + errMsg;
            err_list.push(errMsg);
        } else {
            //   if (isEmptyString(debitMemoBean.lines)) {
            //     let errMsg = "PO Receipt Lines is Required";
            //     errorMessage = errorMessage + errMsg;
            //     err_list.push(errMsg);
            //   }

            if (isEmptyString(debitMemoBean.vendorCode)) {
                let errMsg = "Vendor Code is Required";
                errorMessage = errorMessage + errMsg;
                err_list.push(errMsg);
            }
            if (isEmptyString(debitMemoBean.vendorName)) {
                let errMsg = "Vendor Name is Required";
                errorMessage = errorMessage + errMsg;
                err_list.push(errMsg);
            }
            if (debitMemoBean.debitMemoType === "PREPAID") {
                if (isEmptyString(debitMemoBean.purchaseOrderNumber)) {
                    let errMsg = "PO Number is Required";
                    errorMessage = errorMessage + errMsg;
                    err_list.push(errMsg);
                }
            }
            if (debitMemoBean.debitMemoType === "RETURN") {
                if (isEmptyArray(debitMemoBean.returnLines)) {
                    let errMsg = "ReturnLines is Required";
                    errorMessage = errorMessage + errMsg;
                    err_list.push(errMsg);
                }
            }
            if (debitMemoBean.debitMemoAmount <= 0) {
                let errMsg = "DebitMemoAmount Required ";
                errorMessage = errorMessage + errMsg;
                err_list.push(errMsg);
            }
        }
        if (err_list.length > 0) {
            isValidDebitMemoReceiptBean = false;
            this.setState({ errorList: err_list });

            this.setState({
                alertMessage: err_list,
                alertType: "danger",
                isShowAlert: true,
                // isShowPopupAlert: false,
                // isShowPopupAlertlvl1: false,
                // isShowPopupAlertlvl5: false,
            });
        } else {
            isValidDebitMemoReceiptBean = true;
            this.setState({
                isShowAlert: false,
                // isShowPopupAlert: false,
                // isShowPopupAlertlvl1: false,
                // isShowPopupAlertlvl5: false,
            });
        }
        return isValidDebitMemoReceiptBean;
    };
    saveDebitMemo = () => {
        this.setState({
            isLoading: true,
            loadingText: "Saving ..",
        });
        let debitMemoBean = this.state.debitMemoDataBean;
        debitMemoBean.openAmount = debitMemoBean.debitMemoAmount;
        let isValidLine = false;
        isValidLine = this.validateDebitMemo(debitMemoBean);
        if (isValidLine) {
            if (debitMemoBean.isFetched) {
                if (
                    SecurityAccessManager.DebitMemoMaintenanceUpdate_IsAccessible()
                ) {
                    DebitMemoService.updateDebitMemo(
                        debitMemoBean,
                        this.saveDebitMemoResponse,
                        this.errorCallBack
                    );
                } else {
                    let errMsg = "Access Denied";
                    let errList = [];
                    errList.push(errMsg);

                    this.setState({
                        alertMessage: errList,
                        alertType: "danger",
                        isShowAlert: true,
                    });
                }
            } else {
                if (
                    SecurityAccessManager.DebitMemoMaintenanceCreate_IsAccessible()
                ) {
                    DebitMemoService.createDebitMemo(
                        debitMemoBean,
                        this.saveDebitMemoResponse,
                        this.errorCallBack
                    );
                } else {
                    let errMsg = "Access Denied";
                    let errList = [];
                    errList.push(errMsg);
                    this.setState({
                        alertMessage: errList,
                        alertType: "danger",
                        isShowAlert: true,
                    });
                }
            }
            // else {
            //   this.setState({
            //     isLoading: false,
            //     loadingText: "",
            //   });
            // }
        } else {
            this.setState({
                isLoading: false,
                loadingText: "",
            });
        }
    }

    saveDebitMemoResponse = (response) => {
        this.handleResponse(response.data);
        if (response.data != null && !isEmpty(response.data.debitMemo)) {
            let debitMemoDataBean = response.data.debitMemo;
            let pageTitle = this.moduleCaption + " - EDIT";
            if (debitMemoDataBean != null) {
                this.setState({
                    debitMemoDataBean: debitMemoDataBean,
                    pageTitle: pageTitle,
                    isLoading: false,
                    loadingText: "",
                });

                // this.unlockPurchaseOrderReceipt(purchaseOrderReceiptBean.code);
                // this.editPurchaseOrderReceipt(purchaseOrderReceiptBean.code, false);
                if (!this.isLocked) {
                    this.editDebitMemo(debitMemoDataBean.code);
                } else {
                    this.code = debitMemoDataBean.code;
                    this.unlockDebitMemo(debitMemoDataBean.code);
                }
            }
        }
        this.setState({
            isLoading: false,
            loadingText: "",
        });
    };
    clearError = () => {
        this.setState({ error_list: [] });
    };
    errorCallBack = (error) => {
        ShowError("Error : ", error);
        this.setState({
            isShowProgressBarPopup: false,
            progressLoadingText: " ",
            isLoading: false,
            loadingText: "",

        });
    };
    handleResponse = (response) => {
        let success = false;
        if (response.errors != null) {
            let errMsg = "";
            let errList = [];
            response.errors.map(
                (err) => (
                    (errMsg = errMsg + err.messageDescription),
                    errList.push(err.messageDescription)
                )
            );
            this.setState({ error_list: errList });
            this.setState({
                alertMessage: errList,
                alertType: "danger",
                isShowAlert: true,
            });
            success = false;
        }
        if (response.infos != null) {
            let infoMsg = "";
            let successList = [];
            response.infos.map(
                (info) => (
                    (infoMsg = infoMsg + info.messageDescription),
                    successList.push(info.messageDescription)
                )
            );
            this.setState({
                alertMessage: successList,
                alertType: "success",
                isShowAlert: true,
            });
            success = true;
        }
        return success;
    };
    searchOnChange = (e) => {
        let criteria = this.state.debitMemoSearchCriteria;
        criteria.companyCode = this.companyCode;
        criteria[e.target.name] = e.target.value;
        this.setState({ debitMemoSearchCriteria: criteria });
    };
    loadFirst = () => {
        this.loadPage(1);
    };
    loadPrevious = () => {
        let currentPage = this.state.pageList.currentPage;
        let previousPage = currentPage - 1;
        this.loadPage(previousPage);
    };
    loadNext = () => {
        let currentPage = this.state.pageList.currentPage;
        let nextPage = currentPage + 1;
        this.loadPage(nextPage);
    };
    loadLast = () => {
        let pageSize = this.state.pageList.pageSize;
        let totalCount = this.state.pageList.totalCount;
        let totalPages = totalCount / pageSize;
        totalPages += totalCount % pageSize == 0 ? 0 : 1;
        this.loadPage(totalPages);
    };
    resetDebitMemo = () => {
        let criteria = new DebitMemoSearchCriteria();
        criteria.companyCode = this.companyCode;
        this.state.debitMemoSearchCriteria = criteria;
        this.setState({ debitMemoSearchCriteria: criteria });
        this.loadPage(1);
    };
    filterDebitMemo = () => {
        this.loadPage(1);
    };

    approveDebitMemo = (e) => {
        // if (e.detail == 1) {
        this.setState({
            isLoading: true,
            loadingText: "Approving Purchase Order",
        });
        let debitMemoDataBean = this.state.debitMemoDataBean;
        let input = new RestDebitMemoBeanRequest();
        input.companyCode = this.companyCode;
        input.debitMemoBean = debitMemoDataBean;
        debitMemoDataBean.openAmount = debitMemoDataBean.debitMemoAmount;
        if (debitMemoDataBean.isFetched) {
            input.isLockRequired = true;
        } else {
            input.isLockRequired = false;
        }
        // if (isValidData) {
        let isValidLine = false;
        isValidLine = this.validateDebitMemo(debitMemoDataBean);
        if (isValidLine) {
            if (debitMemoDataBean.isFetched) {
                if (
                    SecurityAccessManager.DebitMemoMaintenanceApproval_IsAccessible()
                ) {
                    DebitMemoService.updateAndApproveDebitMemo(
                        input,
                        this.approveDebitMemoResponse,
                        this.errorCallBack
                    );
                } else {
                    let errMsg = "Access Denied";
                    let errList = [];
                    errList.push(errMsg);
                    this.setState({
                        alertMessage: errList,
                        alertType: "danger",
                        isShowAlert: true,
                    });
                }
            } else {
                if (
                    SecurityAccessManager.DebitMemoMaintenanceApproval_IsAccessible()
                ) {
                    DebitMemoService.createAndApproveDebitMemo(
                        input,
                        this.approveDebitMemoResponse,
                        this.errorCallBack
                    );
                } else {
                    let errMsg = "Access Denied";
                    let errList = [];
                    errList.push(errMsg);
                    this.setState({
                        alertMessage: errList,
                        alertType: "danger",
                        isShowAlert: true,
                    });
                }
            }
        } else {
            this.setState({
                isLoading: false,
                loadingText: "",
            });
        }
        // } else {
        //   this.setState({ isLoading: false, loadingText: "" });
        // }
        // }
    }
    approveDebitMemoResponse = (response) => {
        this.setState({ isLoading: false, loadingText: "" });
        let isSuccess = this.handleApproveResponse(response.data);
        if (isSuccess) {
            if (
                !isEmpty(response.data) &&
                !isEmpty(response.data.mainOperationResponse)
            ) {
                let debitMemo =
                    response.data.mainOperationResponse.debitMemo;
                // if (!this.isLocked) {
                this.editDebitMemo(debitMemo.code);
            }
        }
    }
    handleApproveResponse = (response) => {
        let success = false;
        let infoMsg = "";
        let errMsg = "";
        let errList = [];
        if (!isEmpty(response.mainOperationResponse)) {
            if (!isEmptyArray(response.mainOperationResponse.errors)) {
                response.mainOperationResponse.errors.map(
                    (err) => (
                        (errMsg = errMsg + err.messageDescription),
                        errList.push(err.messageDescription)
                    )
                );
                success = false;
            }
            if (!isEmptyArray(response.mainOperationResponse.infos)) {
                response.mainOperationResponse.infos.map(
                    (info) => (infoMsg = infoMsg + info.messageDescription)
                );
                success = true;
            }
        }
        if (!isEmpty(response.additionalOperationResponse)) {
            if (!isEmptyArray(response.additionalOperationResponse.errors)) {
                response.additionalOperationResponse.errors.map(
                    (err) => (
                        (errMsg = errMsg + err.messageDescription),
                        errList.push(err.messageDescription)
                    )
                );
                success = false;
            }
            if (!isEmptyArray(response.additionalOperationResponse.infos)) {
                response.additionalOperationResponse.infos.map(
                    (info) => (infoMsg = infoMsg + info.messageDescription)
                );
                success = true;
            }
        }
        if (!isEmptyArray(errList) && errList.length > 0) success = false;
        if (!isEmptyString(infoMsg) && !isEmptyString(errMsg)) {
            let msg = infoMsg + errMsg;
            let successMsg = [];
            successMsg.push(msg);
            this.setState({
                alertMessage: successMsg,
                alertType: "success",
                isShowAlert: true,
            });
        } else if (!isEmptyString(infoMsg)) {
            let successMsg = [];
            successMsg.push(infoMsg);
            this.setState({
                alertMessage: successMsg,
                alertType: "success",
                isShowAlert: true,
            });
        } else if (!isEmptyString(errMsg)) {
            let errorMsg = [];
            errorMsg.push(errMsg);
            this.setState({
                alertMessage: errorMsg,
                alertType: "danger",
                isShowAlert: true,
            });
        }
        this.setState({ error_list: errList });
        return success;
    };
    onCancelReasonContinue = () => {
        this.saveCancelDebitMemo();
        this.closeReasonModelCallBack();
    }
    closeReasonModelCallBack = () => {
        this.setState({
            isShowCancelReasonPopup: false,
            reasonData: new ReasonBean(),
            showAutoCompleteReasonList: false,
            reasonPageListForAutoCompleteList: new Array(),
            //   isShowUnApproveReasonPopup: false,
            //   showAutoCompleteUnApproveReasonList: false,
            //   unApproveReasonPageListForAutoCompleteList: new Array(),
            //   isShowLineCancelReasonPopup: false,
        });
    };
    cancelDebitMemo = (e) => {
        if (e.detail == 1) this.openReasonCapture(1);
    };
    saveCancelDebitMemo = () => {
        // this.openReasonCapture(1);
        // let reasonData = new ReasonBean();
        let debitMemoDataBean = this.state.debitMemoDataBean;
        let input = new RestDebitMemoBeanRequest();


        input.companyCode = this.companyCode;
        input.debitMemoBean = debitMemoDataBean;
        input.specialReason = this.state.reasonData;
        // input.updateHeaderStatusFlag = updateHeaderStatusFlag;
        if (SecurityAccessManager.DebitMemoMaintenanceCancel_IsAccessible()) {
            DebitMemoService.cancelDebitMemo(
                input,
                this.debitMemoCancelResponse,
                this.errorCallBack
            );
        } else {
            let errMsg = "Access Denied";
            let errList = [];
            errList.push(errMsg);

            this.setState({
                alertMessage: errList,
                alertType: "danger",
                isShowAlert: true,
            });
        }
    }
    debitMemoCancelResponse = (response) => {
        this.setState({
            isLoading: false,
        });
        let success = this.handleResponse(response.data);
        if (success) {
            if (!isEmpty(response.data) && !isEmpty(response.data.debitMemo)) {
                let debitMemoDataBean = response.data.debitMemo;
                this.setState({ debitMemoDataBean: debitMemoDataBean });
                // this.code = response.data.salesOrder.code;
                // this.unlockSalesOrder(response.data.salesOrder.code);
                if (this.isLocked) {
                    this.code = response.data.debitMemo.code;
                    this.unlockDebitMemo(response.data.debitMemo.code);
                    // this.editSalesOrder(response.data.salesOrder.code);
                }
            }
        }
    };
    openReasonCapture = (type) => {
        if (type === 1) {
            this.setState({
                isShowCancelReasonPopup: true,
            });
        }
        //  else if (type === 2) {
        //     this.setState({
        //         isShowUnApproveReasonPopup: true,
        //     });
        // } else if (type == 3) {
        //     this.setState({
        //         isShowLineCancelReasonPopup: true,
        //     });
        //}
        this.setState({
            showAutoCompleteReasonList: false,
            reasonPageListForAutoCompleteList: new Array(),
        });
    };


    onReasonDescChange = (e) => {
        let reasonData = this.state.reasonData;
        reasonData[e.target.name] = e.target.value;
        this.setState({ reasonData: reasonData });
    };
    onReasonChange = (e) => {
        let code = e.target.value;
        this.state.showAutoCompleteReasonList = true;

        let reasonData = this.state.reasonData;
        let showAutoCompleteList = this.state.showAutoCompleteReasonList;

        if (isEmpty(code)) {
            this.state.showAutoCompleteReasonList = false;
            let showAutoCompleteList = this.state.showAutoCompleteReasonList;
            let reason = this.state.reasonData;
            reason.code = "";
            reason.description = "";
            let suggestion = [];

            this.setState({
                showAutoCompleteReasonList: showAutoCompleteList,
                reasonData: reason,
                reasonPageListForAutoCompleteList: suggestion,
            });
        } else if (showAutoCompleteList === true && code !== "") {
            this.readReasonBySearchString(code);
        }
        if (e.target.name == "code") {
            reasonData["code"] = e.target.value;
            let reasonList = this.state.cancelReasons;
            reasonList.map((rsn) => {
                if (rsn.code == e.target.value) {
                    reasonData["code"] = rsn.code;
                    this.state.showAutoCompleteReasonList = false;
                    let showAutoCompleteList = this.state.showAutoCompleteReasonList;
                    this.setState({ showAutoCompleteReasonList: showAutoCompleteList });
                }
            });
        }

        this.setState({ reasonData: reasonData });
    };
    readReasonBySearchString(searchString) {
        let reasonData = this.state.cancelReasons;
        let simpleAutoCompleteList = new Array();
        if (reasonData.length > 0 && reasonData != null) {
            reasonData.map((reasons) => {
                let simpleItemBean = {
                    code: reasons.code,
                    description: reasons.description,
                };
                simpleAutoCompleteList.push(simpleItemBean);
            });
        }
        let userInput = searchString;

        let filteredSuggestions = new Array();

        filteredSuggestions = simpleAutoCompleteList.filter(
            (simpleAutoCompleteLocationLists) =>
                simpleAutoCompleteLocationLists.code
                    .toLowerCase()
                    .indexOf(userInput.toLowerCase()) > -1
        );
        this.setState({ reasonPageListForAutoCompleteList: filteredSuggestions });
    }
    reasonEnterKeyEventHandler = (e) => {
        let reasonData = this.state.reasonData;
        let code = e.target.value;

        reasonData["code"] = e.target.value;
        let reasonList = this.state.cancelReasons;
        let reasonCodeBean = null;
        reasonList.map((rsn) => {
            if (rsn.code == e.target.value) {
                reasonCodeBean = rsn;
            }
        });
        if (!isEmpty(reasonCodeBean)) {
            let reasonData = this.state.reasonData;
            reasonData.code = reasonCodeBean.code;
            this.setState({
                reasonData: reasonData,
                reasonPageListForAutoCompleteList: new Array(),
            });
        }
    };
    displayAutoCompleteReasonList = (showAutoCompleteList) => {
        this.setState({ showAutoCompleteReasonList: showAutoCompleteList });
    };











    onLineChange = (e) => {
        let tempLineData = this.state.debitMemoReturnLineData;
        tempLineData[e.target.name] = e.target.value;
        this.setState({
            debitMemoReturnLineData: tempLineData,
        });
    };

    rollSkuNumberOnChange = (e) => {

        let debitMemoReturnLineData = this.state.debitMemoReturnLineData;
        debitMemoReturnLineData.companyCode = this.companyCode;
        debitMemoReturnLineData[e.target.name] = e.target.value;
        this.setState({
            debitMemoReturnLineData: debitMemoReturnLineData,
        }, () => {
            if (isEmptyString(this.state.debitMemoReturnLineData.rollSkuNumber) || parseFloat(this.state.debitMemoReturnLineData.rollSkuNumber < 1)) {

                this.resetReturnLineData()
            } else {

                this.setReturnLineData(this.state.debitMemoReturnLineData.rollSkuNumber);
            }

        });

    };
    resetReturnLineData = () => {
        let debitMemoReturnLineData = new DebitMemoReturnLineBean();
        this.setState({
            debitMemoReturnLineData: debitMemoReturnLineData,
        });
    }
    setReturnLineData = (rollSku) => {

        let criteria = new SKUBatchInventorySearchCriteria();
        criteria.companyCode = this.companyCode;
        criteria.rollSkuNumber = rollSku;
        // criteria.locationCode = "WH1";

        let pageInput = new PageListBean();
        let input = new RestSkuBatchInventoryListRequest();
        input.searchCriteria = criteria;
        input.pageInput = pageInput;

        if (SecurityAccessManager.InventoryAdjustmentMaintenance_IsAccessible()) {
            InventoryService.getSkuBatchAllWareHouseInventoryPageList(
                input,
                this.SkuBatchAllWareHouseInventoryResponse,
                this.errorCallBack
            );
        } else {
            let errMsg = "Access Denied";
            let errList = [];
            errList.push(errMsg);

            this.setState({
                alertMessage: errList,
                alertType: "danger",
                isShowAlert: true,
            });
        }
    };
    SkuBatchAllWareHouseInventoryResponse = (response) => {
        let skuBatchInventories = [];
        let skuInventoryData = null;
        if (response.data.skuBatchInventoryPageList != null) {
            if (response.data.skuBatchInventoryPageList.skuBatchInventories != null) {
                skuBatchInventories =
                    response.data.skuBatchInventoryPageList.skuBatchInventories;
                skuBatchInventories.map((ln) => {
                    skuInventoryData = ln;
                });
                if (skuBatchInventories.length > 0) {
                    this.setReturnLineValues(skuInventoryData);
                }
            } else {
                let errMsg = "Enter Valid SKU";
                let errList = [];
                errList.push(errMsg);
                this.setState({
                    alertMessage: errList,
                    alertType: "danger",
                    isShowAlert: true,
                });
            }
        }
    };

    setReturnLineValues = (skuInventoryData) => {
        let debitMemoReturnLineData = this.state.debitMemoReturnLineData;
        if (skuInventoryData != null) {
            debitMemoReturnLineData.fabricStyleCode =
                skuInventoryData.fabricStyleCode;
            debitMemoReturnLineData.fabricStyleName =
                skuInventoryData.fabricStyleName;
            debitMemoReturnLineData.colorCode =
                skuInventoryData.fabricStyleColorCode;
            debitMemoReturnLineData.skuNumber = skuInventoryData.skuNumber;
            debitMemoReturnLineData.uomCode = skuInventoryData.uomCode;
            debitMemoReturnLineData.boxNumber = skuInventoryData.boxNumber;
            debitMemoReturnLineData.vendorBatchNumber =
                skuInventoryData.vendorBatchNumber;
            debitMemoReturnLineData.rollNumber = skuInventoryData.rollNumber;
            debitMemoReturnLineData.locationCode = skuInventoryData.locationCode;
            debitMemoReturnLineData.widthCode = skuInventoryData.widthCode;
            debitMemoReturnLineData.lineTotalReturnQuantity = skuInventoryData.onHandQuantity
            if (!isEmptyString(debitMemoReturnLineData.purchaseOrderNumber) && !isEmptyString(debitMemoReturnLineData.purchaseOrderReceiptNumber)) {
                debitMemoReturnLineData.rollSkuNumber = skuInventoryData.rollSkuNumber;
            }
            debitMemoReturnLineData.isUpdateInventory = true;
            // debitMemoReturnLineData.onHandQuantity =
            //     skuInventoryData.onHandQuantity;
            // debitMemoReturnLineData.binLocation = skuInventoryData.aisleInfoText;
            // debitMemoReturnLineData.isCloseOutInventory =
            //     skuInventoryData.closeOutInventory;
        }


        this.setState({
            debitMemoReturnLineData: debitMemoReturnLineData,
            isShowProgressBarPopup: false,
            progressLoadingText: "",
        });
    }



   

    validateRollLine = (inventoryAdjustmentLineData) => {
        let isValidateRollLine = false;
        let err_list = [];
        let errorMessage = "";
        if (inventoryAdjustmentLineData == null) {
            let errMsg = "Invalid data ";
            errorMessage = errorMessage + errMsg;
            err_list.push(errMsg);
        } else {
            if (isEmptyString(inventoryAdjustmentLineData.rollSkuNumber)) {
                // let errMsg = "RollSkuNumber is Required";
                let errMsg = this.state.is3PL
                    ? "Inventory# is Required"
                    : "RollSKU# is Required";
                errorMessage = errorMessage + errMsg;
                err_list.push(errMsg);
            } else if (isEmptyString(inventoryAdjustmentLineData.fabricStyleCode)) {
                let errMsg = "Invalid item";
                errorMessage = errorMessage + errMsg;
                err_list.push(errMsg);
            }
        }
        if (err_list.length > 0) {
            isValidateRollLine = false;
            this.setState({ errorList: err_list });

            this.setState({
                alertMessage: err_list,
                alertType: "danger",
                isShowAlert: true,
                isShowPopupAlert: false,
            });
        } else {
            isValidateRollLine = true;
            this.setState({ isShowAlert: false, isShowPopupAlert: false });
        }
        return isValidateRollLine;
    };
    deleteReturnLine = (line) => {
        let debitMemoDataBean = this.state.debitMemoDataBean;
        let invoiceLines = [];
        let lineData = debitMemoDataBean.returnLines;
        if (line.isFetched == false) {
            var index = lineData.indexOf(line);
            if (index > -1) {
                lineData.splice(index, 1);
            }
        } else {
        }
        debitMemoDataBean.returnLines = lineData;
        // invoiceLines = checkTransactionData.invoiceLines;
        this.reArrangeReturnLineNumbers(lineData);
        this.setState({
            debitMemoDataBean: debitMemoDataBean,
            // inVoiceSortingLines: invoiceLines,
        }, () => {
            this.clearReturnLineValues()
        })

    };
    reArrangeReturnLineNumbers = (returnList) => {
        let maxLineNumber = 0;
        returnList.map((line) => {
            ++maxLineNumber;
            line.lineNumber = maxLineNumber;
        });
    }
    handleLineNumberClick = (rowData) => {
        let lineDetail = { ...rowData };
        this.setState({ debitMemoReturnLineData: lineDetail });
    }
    addOrUpdateReturnLineChange = (e) => {
        let isValidLine = false;
        let debitMemoReturnLineData = this.state.debitMemoReturnLineData;
        let debitMemoDataBean = this.state.debitMemoDataBean;
        debitMemoReturnLineData.debitMemoNumber = debitMemoDataBean.code;
        let debitReturnLinesList =
            this.state.debitMemoDataBean.returnLines;
        isValidLine = this.validateRollLine(debitMemoReturnLineData);
        if (isValidLine) {
            let isLineFound = false;
            debitReturnLinesList.map((line, i) => {
                if (line.lineNumber == debitMemoReturnLineData.lineNumber) {
                    debitReturnLinesList[i] = debitMemoReturnLineData;
                    isLineFound = true;
                }
            });
            if (!isLineFound)
                debitReturnLinesList.push(debitMemoReturnLineData);
            debitMemoDataBean.returnLines = debitReturnLinesList;
            this.setState({
                debitMemoDataBean: debitMemoDataBean,
                debitMemoReturnLineData:
                    new DebitMemoReturnLineBean(),
            });
            this.clearReturnLineValues();
        }
    };
    clearReturnLineValues = () => {
        let debitMemoDataBean = { ...this.state.debitMemoDataBean };
        let lineNumber = 0;
        let lines = debitMemoDataBean.returnLines;
        lines.map((line) => {
            if (line.lineNumber > lineNumber) {
                lineNumber = line.lineNumber;
            }
        });
        lineNumber++;
        let debitMemoReturnLineData =
            new DebitMemoReturnLineBean();
        debitMemoReturnLineData.debitMemoNumber = debitMemoDataBean.code;
        debitMemoReturnLineData.lineNumber = lineNumber;
        debitMemoReturnLineData.companyCode = this.companyCode;
        debitMemoReturnLineData.isUpdateInventory = true;
        // inventoryAdjustmentLineData.locationCode =
        //   debitMemoDataBean.locationCode;
        // inventoryAdjustmentLineData.onHandQuantity = 0;
        this.setState({
            // debitMemoDataBean: debitMemoDataBean,
            debitMemoReturnLineData: debitMemoReturnLineData,
        });
    };



    mutipleReturnLines = (e) => {
        this.setState(
            {
                isShowMultipleReturnPopup: true,
                rollSkuList: [],
                // vendorInvoicePurchaseOrderData: vendorInvoicePurchaseOrderData,
            }
            // () => {
            //     this.getMultiPurchaseReceiptApproval();
            // }
        );
    }

    closeAlertMultipleReturnLinesModalCallBack = (isShowPopup) => {
        this.setState({
            isShowMultipleReturnPopup: isShowPopup,
            isShowReturnLineAlert: isShowPopup,
        });
    };

    hideAlertCallBackReturn = (mslgType, isDisplayed) => {
        this.setState({
            isShowReturnLineAlert: isDisplayed,
        });
    };




    onPurchaseReceiptChange = (e) => {
        let purchaseOrderReceiptNumber = e.target.value;
        this.state.showAutoCompletepurchaseReceiptList = true;
        let tempCriteria = this.state.debitMemoReturnLineData;
        let showAutoCompleteList = this.state.showAutoCompletepurchaseReceiptList;
        if (isEmpty(purchaseOrderReceiptNumber)) {
            this.state.showAutoCompleteList = false;
            let showAutoCompleteList = this.state.showAutoCompletepurchaseReceiptList;
            let criteria = this.state.debitMemoReturnLineData;
            criteria.purchaseOrderReceiptNumber = "";
            criteria.rollSkuNumber = 0;

            criteria.rollNumber = "";
            criteria.boxNumber = "";
            criteria.vendorBatchNumber = "";
            criteria.uomCode = "";
            criteria.lineTotalReturnQuantity = 0;
            criteria.locationCode = "";
            criteria.fabricStyleCode = "";
            criteria.fabricStyleName = "";
            criteria.colorCode = "";
            criteria.isUpdateInventory = true;
            let suggestion = [];
            this.setState({
                showAutoCompletepurchaseReceiptList: showAutoCompleteList,
                debitMemoReturnLineData: criteria,
                purchaseReceiptPageListForAutoCompleteList: suggestion,
                isShowPurchaseReceiptApproveLookup: false,
            });
        } else if (
            e.target.name == "purchaseOrderReceiptNumber" &&
            showAutoCompleteList === true &&
            purchaseOrderReceiptNumber !== ""
        ) {
            this.readpurchaseReceiptBySearchString(e.target.value);
        }
        tempCriteria[e.target.name] = e.target.value;
        this.setState({ debitMemoReturnLineData: tempCriteria });
    };
    readpurchaseReceiptBySearchString(searchString) {
        let tempCriteria = this.state.debitMemoReturnLineData;
        let receiptCriteria = new PurchaseOrderReceiptSearchCriteria();
        receiptCriteria.companyCode = this.companyCode;
        receiptCriteria.purchaseOrderReceiptNumberStartsWith = searchString;
        receiptCriteria.purchaseOrderNumber = tempCriteria.purchaseOrderNumber;
        let requestInput = new RestPurchaseOrderReceiptListRequest();
        requestInput.pageInput = new RestPageListBean();
        requestInput.searchCriteria = receiptCriteria;
        if (SecurityAccessManager.VendorInvoice_IsAccessible()) {
            PurchaseOrderReceiptService.getPurchaseOrderReceiptPageList(
                requestInput,
                this.loadByPurchaseOrderReceiptResponse,
                this.readBypurchaseReceiptResponseError
            );
        } else {
            let errMsg = "Access Denied";
            let errList = [];
            errList.push(errMsg);

            this.setState({
                alertMessage: errList,
                alertType: "danger",
                isShowAlert: true,
            });
        }
    }
    loadByPurchaseOrderReceiptResponse = (response) => {
        let receiptList =
            response.data.purchaseOrderReceiptPageList.purchaseOrderReceipts;
        let simpleAutoCompleteList = new Array();
        if (receiptList.length > 0 && receiptList != null) {
            receiptList.map((receipt) => {
                let simpleItemBean = {
                    code: receipt.code,
                    description: "",
                };
                simpleAutoCompleteList.push(simpleItemBean);
            });
        }
        this.setState({
            purchaseReceiptPageListForAutoCompleteList: simpleAutoCompleteList,
        });
    };
    readBypurchaseReceiptResponseError = (error) => {
        ShowError("Error : ", error);
    };
    displayAutoCompletepurchaseReceiptList = (
        showAutoCompletepurchaseReceiptList
    ) => {
        this.setState({
            showAutoCompletepurchaseReceiptList: showAutoCompletepurchaseReceiptList,
        });
    };

    purchaseReceiptEnterKeyEventHandler = (e) => {
        this.readPoReceipt(e.target.value);
        this.state.showAutoCompletepurchaseReceiptList = false;
        let showAutoCompletepurchaseReceiptList =
            this.state.showAutoCompletepurchaseReceiptList;
        this.setState({
            poPageListForAutoCompleteList: new Array(),
            showAutoCompletepurchaseReceiptList: showAutoCompletepurchaseReceiptList,
        });
    };

    readPoReceipt = (poReceiptCode) => {
        let input = new RestReadRequest();
        input.companyCode = this.companyCode;
        input.code = poReceiptCode;
        // input.isLoadChildren = true;
        PurchaseOrderReceiptService.readPurchaseOrderReceipt(
            input,
            this.editPoReceiptResponse,
            this.errorCallBack
        );
    };


    editPoReceiptResponse = (response) => {
        let criteria = this.state.debitMemoReturnLineData;
        if (response.data != null && response.data.purchaseOrderReceipt != null) {
            let purchaseOrderReceipt = response.data.purchaseOrderReceipt;
            if (!isEmpty(purchaseOrderReceipt)) {
                //  criteria.vendorName = vendorData.description;
                criteria.purchaseOrderReceiptNumber = purchaseOrderReceipt.code;
                this.setState({
                    debitMemoReturnLineData: criteria,
                    // isShowPurchaseReceiptApproveLookup: true,
                });
                // this.purchaseReceiptApprovalLookup(purchaseOrderReceipt.code);

                if (this.state.isShowMultipleReturnPopup) {
                    this.getMultiPurchaseReceiptRollSku();
                } else {
                    this.rollSkuLookup(purchaseOrderReceipt.code);
                }

            }
        }
    };

    getMultiPurchaseReceiptRollSku = () => {
        let debitMemoReturnLineData =
            this.state.debitMemoReturnLineData;
        // let vendorInvoiceData = this.state.vendorInvoiceData;
        let criteria = new SKUBatchInventorySearchCriteria();
        criteria.companyCode = this.companyCode;
        criteria.purchaseOrderNumber =
            debitMemoReturnLineData.purchaseOrderNumber;
        criteria.purchaseReceitpNumber =
            debitMemoReturnLineData.purchaseOrderReceiptNumber;
        // if (!isEmptyString(vendorInvoiceData.vendorCode)) {
        //     criteria.vendorCode = vendorInvoiceData.vendorCode;
        // }
        // criteria.isExcludePaidFlag = true;
        let pageList = new PageListBean();

        let requestInput = new RestSkuBatchInventoryListRequest();
        requestInput.searchCriteria = criteria;
        requestInput.pageInput = pageList;
        this.loadMultipleRollSkuList(requestInput);
    }
    loadMultipleRollSkuList = (requestInput) => {
        //  if (SecurityAccessManager.VendorInvoice_IsAccessible()) {
        InventoryService.getSkuBatchDetailsForPurchaseReceipt(
            requestInput,
            this.loadMultipleRollSkuResponse,
            this.errorCallBack
        );
        //}
    }



    rollSkuLookup = (receiptNumber) => {
        let rollSkuLookupHandler = new RollSkuLookupHandler(
            this.companyCode,
            "ROLLSKU",
            "",
            "",
            receiptNumber
        );
        let lookup_data = [];
        let lookupdata = rollSkuLookupHandler.lookupdata;
        lookupdata.map((data) => {
            lookup_data.push(data);
        });
        this.setState({ rollSkuLookupHandler: rollSkuLookupHandler, lookup_data: lookup_data, });
    };


    loadMultipleRollSkuResponse = (response) => {
        let debitMemoDataBean = this.state.debitMemoDataBean;
        let rollSkuList = [];
        let rollSkuLookupHandler = null;
        if (response.data.skuBatchInventoryPageList != null) {
            if (response.data.skuBatchInventoryPageList.skuBatchInventories != null) {
                rollSkuList = response.data.skuBatchInventoryPageList.skuBatchInventories;

                 if (!isEmptyArray(debitMemoDataBean.returnLines)) {

                        if (!isEmptyArray(debitMemoDataBean.returnLines)) {
                          const usedCodes = debitMemoDataBean.returnLines.map(
                            (po) => po.rollSkuNumber
                          );
                
                          rollSkuList = rollSkuList.filter(
                            (item) => !usedCodes.includes(item.rollSkuNumber)
                          );
                        }
                      }

            }
        }

        this.setState({
            rollSkuList: rollSkuList,
            // rollSkuLookupHandler: rollSkuLookupHandler,
        });
    }

    //

    onRollSkuChange = (e) => {
        let rollSkuNumber = e.target.value;
        this.state.isShowAutoRollSKutList = true;
        let tempCriteria = this.state.debitMemoReturnLineData;
        let showAutoCompleteList = this.state.isShowAutoRollSKutList;
        if (isEmpty(rollSkuNumber)) {
            this.state.isShowAutoRollSKutList = false;
            let showAutoCompleteList = this.state.isShowAutoRollSKutList;
            let criteria = this.state.debitMemoReturnLineData;
            criteria.rollSkuNumber = 0;
            criteria.rollNumber = "";
            criteria.boxNumber = "";
            criteria.vendorBatchNumber = "";
            criteria.uomCode = "";
            criteria.lineTotalReturnQuantity = 0;
            criteria.locationCode = "";
            criteria.fabricStyleCode = "";
            criteria.fabricStyleName = "";
            criteria.colorCode = "";
            criteria.isUpdateInventory = true;


            let suggestion = [];
            this.setState({
                isShowAutoRollSKutList: showAutoCompleteList,
                debitMemoReturnLineData: criteria,
                rollSkuPageListForAutoCompleteList: suggestion,
            });
        } else if (
            e.target.name == "rollSkuNumber" &&
            showAutoCompleteList === true &&
            rollSkuNumber !== ""
        ) {
            this.readRollSkuBySearchString(e.target.value);
        }
        tempCriteria["rollSkuNumber"] = e.target.value;
        // this.readRollSku(rollSkuNumber);
        this.setState({ debitMemoReturnLineData: tempCriteria });
    };
    rollSKuEnterKeyEventHandler = (e) => {
        let rollSkuNumber = e.target.value;
        this.setState({
            isShowProgressBarPopup: true,
            progressLoadingText: "Reading...",
        });
        this.setReturnLineData(e.target.value);
        this.setState({
            rollSkuPageListForAutoCompleteList: new Array(),
            isShowAutoRollSKutList: false,
        });
    };

    readApplyRollResponseError = (error) => {
        ShowError("Error : ", error);
    };
    readApplyRollSkuResponse = (response) => {
        if (
            !isEmpty(response.data) &&
            !isEmpty(response.data.skuBatchInventoryPageList) &&
            !isEmptyArray(response.data.skuBatchInventoryPageList.skuBatchInventories)
        ) {
            let listData =
                response.data.skuBatchInventoryPageList.skuBatchInventories;
            let rollSkuData = [];
            listData.map((obj) => {
                if (obj.onHandQuantity > 0) {
                    rollSkuData.push(obj);
                }
            });
            let simpleAutoCompleteList = new Array();
            if (rollSkuData.length > 0 && rollSkuData != null) {
                rollSkuData.map((rollSku) => {
                    let simpleItemBean = {
                        code: rollSku.rollSkuNumber,
                        description: "",
                    };
                    simpleAutoCompleteList.push(simpleItemBean);
                });
            }
            let userInput = this.state.userInput;
            let filteredSuggestions = new Array();
            filteredSuggestions = simpleAutoCompleteList.filter(
                (list) => list.code.toString().indexOf(userInput.toString()) > -1
            );
            this.setState({
                rollSkuPageListForAutoCompleteList: filteredSuggestions,
            });
        }
    };

    readRollSkuBySearchString(searchString) {
        // let rollSkuData = [];
        // let rollSkuLookupHandler = this.state.rollSkuLookupHandler.lookupdata;
        // rollSkuLookupHandler.map((sku) => {
        //   rollSkuData.push(sku);
        // });
        // let simpleAutoCompleteList = new Array();
        // if (rollSkuData.length > 0 && rollSkuData != null) {
        //   rollSkuData.map((rollSku) => {
        //     let simpleItemBean = {
        //       code: rollSku.rollSkuNumber,
        //     };
        //     simpleAutoCompleteList.push(simpleItemBean);
        //   });
        // }
        // let userInput = searchString;
        // let filteredSuggestions = new Array();
        // filteredSuggestions = simpleAutoCompleteList.filter(
        //   (list) =>
        //     list.rollSkuNumber.toLowerCase().indexOf(userInput.toLowerCase()) > -1
        // );
        // this.setState({ rollSkuPageListForAutoCompleteList: filteredSuggestions });
        let debitMemoReturnLineData = this.state.debitMemoReturnLineData;
        let rollSkuCriteria = new SKUBatchInventorySearchCriteria();
        let criteria = this.state.debitMemoReturnLineData;
        rollSkuCriteria.companyCode = this.companyCode;
        rollSkuCriteria.purchaseOrderNumber =
            debitMemoReturnLineData.purchaseOrderNumber;
        rollSkuCriteria.purchaseReceitpNumber =
            debitMemoReturnLineData.purchaseOrderReceiptNumber;
        let roll_pageList = new RestPageListBean();
        roll_pageList.pageSize = 100;
        let requestInput = new RestSkuBatchInventoryListRequest();
        requestInput.pageInput = roll_pageList;
        requestInput.searchCriteria = rollSkuCriteria;
        this.setState({ userInput: searchString });
        InventoryService.getSkuBatchDetailsForPurchaseReceipt(
            requestInput,
            this.readApplyRollSkuResponse,
            this.readApplyRollResponseError
        );
    }

    displayAutoCompleteRollSkuList = (isShowAutoRollSKutList) => {
        this.setState({
            isShowAutoRollSKutList: isShowAutoRollSKutList,
        });
    };

    //

    purchaseOrderReturnOnChange = (e) => {
        let PurchaseOrderNumber = e.target.value;
        this.state.isShowAutoCompleteReturnPoList = true;
        let tempData = this.state.debitMemoReturnLineData;
        let showAutoCompleteList = this.state.isShowAutoCompleteReturnPoList;
        if (isEmpty(PurchaseOrderNumber)) {
            this.state.isShowAutoCompleteReturnPoList = false;
            let showAutoCompleteList = this.state.isShowAutoCompleteReturnPoList;
            let tempData = this.state.debitMemoReturnLineData;
            tempData.purchaseOrderNumber = "";
            tempData.purchaseOrderReceiptNumber = "";
            tempData.rollSkuNumber = 0;
            // tempData.purchaseOrderReceiptApprovalNumber = "";


            //criteria.rollSkuNumber = 0;
            tempData.rollNumber = "";
            tempData.boxNumber = "";
            tempData.vendorBatchNumber = "";
            tempData.uomCode = "";
            tempData.lineTotalReturnQuantity = 0;
            tempData.locationCode = "";
            tempData.fabricStyleCode = "";
            tempData.fabricStyleName = "";
            tempData.colorCode = "";
            tempData.isUpdateInventory = true;

            let suggestion = [];
            this.setState({
                isShowAutoCompleteReturnPoList: showAutoCompleteList,
                debitMemoReturnLineData: tempData,
                poPageListForReturnAutoCompleteList: suggestion,
                isShowPurchaseReceiptLookup: false,
            });
        } else if (
            e.target.name == "purchaseOrderNumber" &&
            showAutoCompleteList === true &&
            PurchaseOrderNumber !== ""
        ) {
            this.readPOByReturnSearchString(e.target.value);
            //this.readPurchaseOrder(e.target.value);
        }
        tempData[e.target.name] = e.target.value.toUpperCase();
        this.setState({
            debitMemoReturnLineData: tempData,
        });
    };
    poReturnEnterKeyEventHandler = (e) => {
        this.setState({
            isShowProgressBarPopup: true,
            progressLoadingText: "Reading PurchaseOrder",
        });
        this.readReturnPurchaseOrder(e.target.value);
        this.state.isShowAutoCompleteReturnPoList = false;
        let showAutoCompleteList = this.state.isShowAutoCompleteReturnPoList;
        this.setState({
            poPageListForReturnAutoCompleteList: new Array(),
            isShowAutoCompleteReturnPoList: showAutoCompleteList,
        });
    };

    readReturnPurchaseOrder = (purchaseOrderCode) => {
        let readrestInput = new RestReadRequest();
        readrestInput.companyCode = this.companyCode;
        readrestInput.code = purchaseOrderCode;
        if (SecurityAccessManager.VendorInvoice_IsAccessible()) {
            PurchaseOrderService.readPurchaseOrder(
                readrestInput,
                this.readPurchaseOrderReturnResponse,
                this.errorCallBack
            );
        } else {
            let errMsg = "Access Denied";
            let errList = [];
            errList.push(errMsg);

            this.setState({
                alertMessage: errList,
                alertType: "danger",
                isShowAlert: true,
            });
        }
    };
    readPurchaseOrderReturnResponse = (response) => {
        let poBean = response.data.purchaseOrder;
        if (poBean != null) {
            // let purchaseOrderData = new VendorInvoicePurchaseOrderBean();
            //purchaseOrderData.companyCode = this.companyCode;
            let debitMemoReturnLineData = this.state.debitMemoReturnLineData;
            debitMemoReturnLineData.purchaseOrderNumber = poBean.code;
            //   purchaseOrderData.purchaseOrderDate = poBean.orderStartDate;
            //   purchaseOrderData.purchaseOrderStopDate = poBean.orderStopDate;
            //   purchaseOrderData.vendorInvoiceCode = this.state.vendorInvoiceData.code;
            this.setState(
                {
                    debitMemoReturnLineData: debitMemoReturnLineData,
                    isShowPurchaseReceiptLookup: true,
                },
                () => {
                    this.purchaseReceiptLookup(poBean.code);
                    // this.getMultiPurchaseReceiptApproval();
                }
            );
        }
        this.setState({
            isShowProgressBarPopup: false,
            progressLoadingText: "",
        });
    };

    purchaseReceiptLookup = (purchaseOrderNumber) => {
        let purchaseReceiptLookupHandler = new PurchaseOrderReceiptLookupHandler(
            this.companyCode,
            "Purchase Receipt",
            purchaseOrderNumber
        );
        this.setState({
            purchaseReceiptLookupHandler: purchaseReceiptLookupHandler,
        });
    };

    readPOByReturnSearchString(searchString) {
        let searchCriteria = new PurchaseOrderSearchCriteria();
        searchCriteria.companyCode = this.companyCode;
        searchCriteria.purchaseOrderNumberStartsWith = searchString;
        searchCriteria.purchaseOrderNumberContains = searchString;
        searchCriteria.vendorCode = this.state.debitMemoDataBean.vendorCode;
        searchCriteria.orderStatus = "R";
        let cust_pageList = new PageListBean();
        cust_pageList.pageSize = 100;
        let cust_requestInput = new RestPurchaseOrderListRequest();
        cust_requestInput.pageInput = cust_pageList;
        cust_requestInput.searchCriteria = searchCriteria;
        PurchaseOrderService.getPurchaseOrderPageList(
            cust_requestInput,
            this.readPurchaseOrderReturnBySearchStringResponse,
            this.readPurchaseOrderBySearchStringError
        );
    }
    readPurchaseOrderReturnBySearchStringResponse = (response) => {
        let purchaseorderData = response.data.purchaseOrderPageList.purchaseOrders;
        let simpleAutoCompleteList = new Array();
        if (purchaseorderData.length > 0 && purchaseorderData != null) {
            purchaseorderData.map((po) => {
                let simpleItemBean = {
                    code: po.code,
                    description: "",
                };
                simpleAutoCompleteList.push(simpleItemBean);
            });
        }
        this.setState({
            poPageListForReturnAutoCompleteList: simpleAutoCompleteList,
        });
    };
    readPurchaseOrderByReturnSearchStringError = (error) => {
        ShowError("Error : " + error);
    };
    displayPoAutoCompleteReturnList = (showAutoCompleteList) => {
        this.setState({ isShowAutoCompleteReturnPoList: showAutoCompleteList });
    };



    //

    onSelectedQtyLines = (evt, line) => {
        let rollSkuList = { ...line };
        this.state.rollSkuList.map((select) => {
            if (select.rollSkuNumber == line.rollSkuNumber) {
                select.isSelected = evt.target.value;
            }
        });
    }
    MultiLinesColumn = () => {
        const columns = new Array();

        columns.push(
            new ColumnDefinition()
                .setDetails("", "isSelected", false)
                .setInputDetails(
                    false,
                    false,
                    true,
                    null,
                    this.onSelectedQtyLines,
                    null
                )
                .setStyleDetails("", "", "", "wt-1-5 ", "wt-1-5 ")
        );

        columns.push(
            new ColumnDefinition()
                .setDetails(this.state.is3PL ? "Item#" : "FabricStyle#", "fabricStyleCode", true)
                .setStyleDetails("left", "", "", "wt-4 ", "wt-4 ")
        );
        columns.push(
            new ColumnDefinition()
                .setDetails("Name", "fabricStyleName", true)

                .setStyleDetails("left", "10", "", "wt-4", "wt-4")
        );


        columns.push(
            new ColumnDefinition()
                .setDetails("Vendor", "vendorCode", true)
                .setStyleDetails("left", "", "", "wt-4 ", "wt-4 ")
        );

        columns.push(
            new ColumnDefinition()
                .setDetails("PO#", "purchaseOrderNumber", true)
                .setStyleDetails("left", "", "", "wt-4 ", "wt-4 ")

        );

        columns.push(
            new ColumnDefinition()
                .setDetails("PR#", "purchaseOrderReceiptNumber", true)
                .setStyleDetails("left", "", "", "wt-4 ", "wt-4 ")

        );

        columns.push(
            new ColumnDefinition()
                .setDetails("RollSku", "rollSkuNumber", true)
                .setStyleDetails("left", "", "", "wt-4 ", "wt-4 ")
        );




        columns.push(
            new ColumnDefinition()
                .setDetails("ReturnQty", "onHandQuantity", true)
                // .setHeaderDetails( )
                .setStyleDetails("right", "", "", "wt-2 ", "wt-2")
                .setInputDetails(
                    false,
                    true,
                    false,
                    this.onLineQtyChange,
                    null,
                    this.onLineQtyBlur
                )
        );

        return columns;
    };


    onLineQtyChange = (evt, data) => {

        this.state.rollSkuList.map((line) => {
            if (line.rollSkuNumber === data.rollSkuNumber) {
                line[evt.target.name] = evt.target.value;
                line.isSelected = true;
            }
        });

    };
    onLineQtyBlur = (evt, row) => { };
    getReturnLineNumber() {
        let maxLineNumber = 0;
        let debitMemoReturnLines = this.state.debitMemoDataBean.returnLines;
        if (debitMemoReturnLines.length > 0)
            debitMemoReturnLines.map((line) => {
                if (line.lineNumber > maxLineNumber) {
                    maxLineNumber = line.lineNumber;
                }
            });
        return maxLineNumber;
    }

    MultipleReturnLines = () => {
        let rollSkuList = [...this.state.rollSkuList];
        let debitMemoDataBean = this.state.debitMemoDataBean;
        //let VendorInvoicePurchaseOrderBean = new VendorInvoicePurchaseOrderBean();
        let vendorInvoicePurchaseOrderData =
            this.state.vendorInvoicePurchaseOrderData;
        let rollSkuReturnLines = [];
        if (!isEmptyArray(debitMemoDataBean.returnLines)) {
            rollSkuReturnLines = debitMemoDataBean.returnLines;
        }
        let lineNumber = this.getReturnLineNumber();
        if (!isEmptyArray(rollSkuList)) {
            for (let list of rollSkuList) {
                if (list.isSelected) {
                    let returnData = new DebitMemoReturnLineBean();
                    returnData.fabricStyleCode = list.fabricStyleCode;
                    returnData.fabricStyleName = list.fabricStyleName;
                    returnData.colorCode = list.fabricStyleColorCode;
                    returnData.lineNumber = ++lineNumber;
                    returnData.skuNumber = list.skuNumber;
                    returnData.uomCode = list.uomCode;
                    returnData.boxNumber = list.boxNumber;
                    returnData.vendorBatchNumber = list.vendorBatchNumber;
                    returnData.rollNumber = list.rollNumber;
                    returnData.locationCode = list.locationCode;
                    returnData.widthCode = list.widthCode;
                    returnData.lineTotalReturnQuantity = list.onHandQuantity;
                    returnData.rollSkuNumber = list.rollSkuNumber;
                    returnData.purchaseOrderNumber = list.purchaseOrderNumber;
                    returnData.purchaseOrderReceiptNumber = list.purchaseOrderReceiptNumber;
                    returnData.isUpdateInventory = true;
                    rollSkuReturnLines.push(returnData);
                }
                debitMemoDataBean.returnLines = rollSkuReturnLines;
            }
        }

        this.setState({
            debitMemoDataBean: debitMemoDataBean,
            isShowMultipleReturnPopup: false,
        });
        this.clearReturnLineValues();
    }


    render() {
        let moduleOrderStatus = "";
        let debitMemoStatus = ModuleUtils.getDebitMemoStatusCaption(
            this.state.debitMemoDataBean.debitMemoStatus
        );
        if (debitMemoStatus !== undefined && debitMemoStatus !== null) {
            moduleOrderStatus = debitMemoStatus;
        }
        let debitMemoReturnLineData = this.state.debitMemoReturnLineData;
        return (
            <div >
                <ProgressBar
                    progressLoadingText={this.state.progressLoadingText}
                    isShowPopup={this.state.isShowProgressBarPopup}
                />
                {this.state.isSpecialViewMode == false ? (
                    <AlertToolBox
                        alertMsgList={this.state.alertMessage}
                        alertErrorType={this.state.alertType}
                        isShowAlert={this.state.isShowAlert}
                        hideAlertCallBack={this.hideAlertCallBack}
                    />
                ) : null}

                <ModuleToolBar
                    isShowNewButton={false}
                    onNewEntry={() => this.addNewEntry()}
                    onModuleExit={() => this.moduleExit()}
                    resetView={() => this.resetView()}
                    pageTitle={this.state.pageTitle}
                    loadingText={this.state.loadingText}
                    isLoading={this.state.isLoading}
                    isShowModuleSearchContainer={this.state.isShowModuleSearchContainer}
                    isMaintenanceMode={this.state.isMaintenanceMode}
                    onModuleKeyContainerButtonClick={this.editDebitMemo}
                    moduleKeyCode={this.state.moduleKeyCode}
                    onModuleKeyCodeChange={this.onModuleKeyCodeChange}
                    getModuleListView={this.getModuleListView}
                    lookupRequired={true} //for f2 lookup
                    lookupHandler={this.state.debitMemoLookHandler} //for f2 lookup
                    showCriteriaDialog={true} //for f2 lookup
                    onModuleKeyCodeWithCriteriaOnChange={
                        this.onModuleKeyCodeWithCriteriaOnChange
                    }
                    selectButtonClick={this.selectButtonClick}
                    disabled={this.state.disabled}
                    isSpecialViewMode={this.state.isSpecialViewMode}
                    isResetView={this.state.isResetView}
                    isFocusLookup={this.state.isFocusLookup}
                />

                {!this.state.isDebitMemoListFormOpen &&
                    this.state.isSpecialViewMode == false &&
                    this.state.isViewMode == false && (
                        <BaseToolBar
                            pageTitle={this.state.pageTitle}
                            back={this.back}
                            save={this.save}
                            isShowSaveButton={this.state.isShowSaveButton}
                            clearError={this.clearError}
                            isShowClearErrorButton={this.state.isShowClearErrorButton}
                            // generatePDF={this.generatePDF}
                            // isShowPDFButton={this.state.isShowPDFReportButton}
                            extend_toolbar={
                                <>
                                    {/* {this.state.isShowExcelButton && (
                                    <Button
                                        className="header_buttons secondary"
                                        size="sm"
                                        onClick={(e) => this.generateExcel(e)}
                                    >
                                        Excel
                                    </Button>
                                )} */}
                                    {this.state.isShowApproveButton && (
                                        <Button
                                            className="header_buttons secondary"
                                            size="sm"
                                            onClick={(e) => this.approveDebitMemo(e)}
                                        >
                                            Approve
                                        </Button>
                                    )}
                                    {this.state.isShowCancelButton && (
                                        <Button
                                            className="header_buttons secondary"
                                            size="sm"
                                            onClick={(e) => this.cancelDebitMemo(e)}
                                        >
                                            Cancel
                                        </Button>
                                    )}
                                    {/* {this.state.isShowCreateInvoiceButton && this.state.is3PL && (
                                    <Button
                                        className="header_buttons secondary"
                                        size="sm"
                                        onClick={(e) => this.openCreateInvoicePopup(e)}
                                    >
                                        CreateInvoice
                                    </Button>
                                )} */}
                                </>
                            }
                        />
                    )}

                <ReasonCaptureComponent
                    ref={this.cancelReasonDialogRef}
                    reasons={this.state.cancelReasons}
                    reasonData={this.state.reasonData}
                    title="DebitMemo Cancel"
                    onChange={this.onReasonChange}
                    onClick={this.onCancelReasonContinue}
                    isShowPopup={this.state.isShowCancelReasonPopup}
                    closeReasonModelCallBack={this.closeReasonModelCallBack}
                    reasonEnterKeyEventHandler={this.reasonEnterKeyEventHandler}
                    reasonPageListForAutoCompleteList={
                        this.state.reasonPageListForAutoCompleteList
                    }
                    displayAutoCompleteReasonList={this.displayAutoCompleteReasonList}
                    showAutoCompleteReasonList={this.state.showAutoCompleteReasonList}
                    onReasonDescChange={this.onReasonDescChange}
                />
                {/* <ReasonCaptureComponent
                              ref={this.unapproveReasonDialogRef}
                              reasons={this.state.unapprovalReasons}
                              reasonData={this.state.reasonData}
                              title="SalesOrder UnApprove"
                              onChange={this.onUnApproveReasonChange}
                              onClick={this.onUnApproveReasonContinue}
                              isShowPopup={this.state.isShowUnApproveReasonPopup}
                              closeReasonModelCallBack={this.closeReasonModelCallBack}
                              reasonEnterKeyEventHandler={this.unApproveReasonEnterKeyEventHandler}
                              reasonPageListForAutoCompleteList={
                                this.state.unApproveReasonPageListForAutoCompleteList
                              }
                              displayAutoCompleteReasonList={
                                this.displayAutoCompleteUnApproveReasonList
                              }
                              showAutoCompleteReasonList={
                                this.state.showAutoCompleteUnApproveReasonList
                              }
                              onReasonDescChange={this.onReasonDescChange}
                            /> */}
                {this.state.isShowNodes && (
                    <BaseNodeBar
                        nodeList={this.state.nodeList}
                        selectedModuleKey={this.state.selectedNodeKey}
                        nodeOnSelect={this.nodeOnSelect}
                        moduleStatus={moduleOrderStatus}
                    />
                )}

                {!this.state.isShowNodes &&
                    !this.state.isDebitMemoListFormOpen &&
                    this.state.isDebitMemoEntryFormOpen &&
                    !this.state.isDebitMemoAppliedFormOpen &&
                    this.getHeaderView()}
                {this.state.isShowNodes &&
                    !this.state.isDebitMemoListFormOpen &&
                    this.state.isDebitMemoEntryFormOpen &&
                    !this.state.isDebitMemoAppliedFormOpen &&
                    this.getHeaderView()}
                {/* {!this.state.isShowNodes &&
                    this.state.isDebitMemoListFormOpen &&
                    !this.state.isDebitMemoEntryFormOpen &&
                    !this.state.isDebitMemoAppliedFormOpen &&
                    this.getListView()} */}
                {this.state.isDebitMemoListFormOpen &&
                    !this.state.isSpecialViewMode &&
                    this.getListView()}
                {this.state.isShowNodes &&
                    !this.state.isDebitMemoListFormOpen &&
                    !this.state.isDebitMemoEntryFormOpen &&
                    this.state.isDebitMemoAppliedFormOpen &&
                    this.getAppliedTransactionView()}
                {this.state.isShowNodes &&
                    !this.state.isDebitMemoListFormOpen &&
                    !this.state.isDebitMemoEntryFormOpen &&
                    !this.state.isDebitMemoAppliedFormOpen &&
                    this.state.isDebitMemoHistoryFormOpen &&
                    this.getHistoryView()}




                <MultiViewPopup
                    popupLvlClass={"popupSizeLevel0"}
                    isModulePopup={false}
                    isShowPopup={this.state.isShowMultipleReturnPopup}
                    closeOnEsc={false}
                    closeAlertModalCallBack={this.closeAlertMultipleReturnLinesModalCallBack}
                    title={"Multiple Return Line"}
                    closeOnDocumentClick={false}
                    lineFunctionalityForm={this.lineFunctionalityForm}
                    lockScroll={true}
                    alertContainerBox={
                        <AlertToolBox
                            alertMsgList={this.state.alertMessage}
                            alertErrorType={this.state.alertType}
                            isShowAlert={this.state.isShowReturnLineAlert}
                            hideAlertCallBack={this.hideAlertCallBackReturn}
                        />
                    }
                    headerButtonContainer={
                        <div className="floatLeft">
                            <Button
                                className="header_buttons enterFocus"
                                size="sm"
                                onClick={(e) => this.MultipleReturnLines(e)}
                            // disabled={isCreateButtonDisabled}
                            >
                                AddMultiReturn
                            </Button>
                        </div>
                    }
                    content={
                        <div>
                            <Row>
                                <Col sm="1">
                                    <FormLabel>Company</FormLabel>
                                </Col>
                                <Col sm="2">
                                    <InputTextbox
                                        name="companyCode"
                                        value={this.state.debitMemoDataBean.companyCode}
                                        disabled={true}
                                    />
                                </Col>
                                <Col sm="1">
                                    <FormLabel>Vendor</FormLabel>
                                </Col>
                                <Col sm="2">
                                    <InputTextbox
                                        name="vendorCode"
                                        value={this.state.debitMemoDataBean.vendorCode}
                                        disabled={true}
                                    />
                                </Col>
                                <Col sm="1">
                                    <FormLabel>Purchase#</FormLabel>{" "}
                                </Col>
                                <Col sm="2">
                                    <InputTextbox
                                        onChange={this.purchaseOrderReturnOnChange}
                                        name="purchaseOrderNumber"
                                        // ref={this.purchaseRef}
                                        value={debitMemoReturnLineData.purchaseOrderNumber}
                                        lookupRequired={true}
                                        lookupHandler={this.state.purchaseorderLookupHandler}
                                        showCriteriaDialog={true}
                                        enterKeyEventHandler={this.poReturnEnterKeyEventHandler}
                                        autoCompleteListData={
                                            this.state.poPageListForReturnAutoCompleteList
                                        }
                                        enableAutoCompleteTextBox={true}
                                        displayAutoCompleteList={this.displayPoAutoCompleteReturnList}
                                        showAutoCompleteList={this.state.isShowAutoCompleteReturnPoList}
                                        // disabled={!this.state.isShowPOLookup}
                                        //isMandatory={true}
                                        isMandatory={true}
                                    />
                                </Col>
                                <Col sm="1">
                                    <FormLabel>PurchaseReceipt#</FormLabel>{" "}
                                </Col>
                                <Col sm="2">
                                    <InputTextbox
                                        onChange={this.onPurchaseReceiptChange}
                                        //  ref={this.receiptCodeRef}
                                        name="purchaseOrderReceiptNumber"
                                        placeholder="purchaseOrderReceiptNumber"
                                        value={
                                            debitMemoReturnLineData.purchaseOrderReceiptNumber
                                        }
                                        lookupRequired={this.state.isShowPurchaseReceiptLookup}
                                        //lookupRequired={true}
                                        lookupHandler={this.state.purchaseReceiptLookupHandler}
                                        showCriteriaDialog={true}
                                        enterKeyEventHandler={
                                            this.purchaseReceiptEnterKeyEventHandler
                                        }
                                        autoCompleteListData={
                                            this.state.purchaseReceiptPageListForAutoCompleteList
                                        }
                                        enableAutoCompleteTextBox={true}
                                        displayAutoCompleteList={
                                            this.displayAutoCompletepurchaseReceiptList
                                        }
                                        showAutoCompleteList={
                                            this.state.showAutoCompletepurchaseReceiptList
                                        }
                                        //   disabled={isDisabledFields}
                                        isMandatory={true}

                                    />
                                </Col>

                                {/* <Col sm="2">
                                      <InputTextbox
                                        onChange={this.purchaseOrderOnChange}
                                        name="purchaseOrderNumber"
                                        ref={this.purchaseRef}
                                        value={vendorInvoicePurchaseOrderData.purchaseOrderNumber}
                                        lookupRequired={this.state.isShowPOLookup}
                                        lookupHandler={this.state.purchaseorderLookupHandler}
                                        showCriteriaDialog={true}
                                        enterKeyEventHandler={this.poEnterKeyEventHandler}
                                        autoCompleteListData={
                                          this.state.poPageListForAutoCompleteList
                                        }
                                        enableAutoCompleteTextBox={true}
                                        displayAutoCompleteList={this.displayPoAutoCompleteList}
                                        showAutoCompleteList={this.state.isShowAutoCompletePoList}
                                        disabled={!this.state.isShowPOLookup}
                                        isMandatory={true}
                                      />
                                    </Col> */}

                                {/* <Col sm="1">
                                    <FormLabel className="header_labels">POReceipt#</FormLabel>{" "}
                                </Col>
                                <Col sm="2">
                                    <InputTextbox
                                        onChange={this.onPurchaseReceiptChange}
                                        //  ref={this.receiptCodeRef}
                                        name="purchaseOrderReceiptNumber"
                                        placeholder="purchaseOrderReceiptNumber"
                                        value={
                                            debitMemoReturnLineData.purchaseOrderReceiptNumber
                                        }
                                        // lookupRequired={this.state.isShowPurchaseReceiptLookup}
                                        lookupRequired={true}
                                        lookupHandler={this.state.purchaseReceiptLookupHandlerMulti}
                                        showCriteriaDialog={true}
                                        enterKeyEventHandler={
                                            this.purchaseReceiptEnterKeyEventHandler
                                        }
                                        autoCompleteListData={
                                            this.state.purchaseReceiptPageListForAutoCompleteList
                                        }
                                        enableAutoCompleteTextBox={true}
                                        displayAutoCompleteList={
                                            this.displayAutoCompletepurchaseReceiptList
                                        }
                                        showAutoCompleteList={
                                            this.state.showAutoCompletepurchaseReceiptList
                                        }
                                        //   disabled={isDisabledFields}
                                        isMandatory={true}
                                    ></InputTextbox>
                                </Col> */}
                            </Row>

                            <div className="mt-3">
                                <CustomTable
                                    data={this.state.rollSkuList}
                                    columns={this.MultiLinesColumn()}
                                    label={"Return Lines"}
                                />
                            </div>
                        </div>
                    }
                />
            </div>
        );
    }
}


class DebitMemoEntryForm extends React.Component {
    static contextType = AppContext;
    constructor(props) {
        super(props);
        this.vendorCodeRef = React.createRef();
        this.state = {

            vendorLookupHandler: null,
            purchaseOrderReturnLookupHandler: null,
            debitMemoTypeLookupHandler: null,
        }

    }
    componentDidMount() {
        const { appData } = this.context;
        this.companyCode = appData.companyCode;
        this.initLookupHandlers();
        this.setInputFocus();
    }
    setInputFocus() {
        if (this.vendorCodeRef.current != null) {
            this.vendorCodeRef.current.focus();
        }
    }
    initLookupHandlers = () => {
        let vendorLookupHandler = new VendorLookupHandler(
            this.companyCode,
            "Vendor"
        );
        this.setState({ vendorLookupHandler: vendorLookupHandler });

        let fabricLookupHandler = new FabricStyleLookupHandler(
            this.companyCode,
            this.props.is3PL ? "Item" : "Fabric Style"
        );
        this.setState({ fabricLookupHandler: fabricLookupHandler });
        // let purchaseOrderReturnLookupHandler = new PurchaseOrderLookupHandler(
        //     this.companyCode,
        //     "PurchaseOrder",
        //     this.props.debitMemoDataBean.vendorCode
        // );
        // this.setState({ purchaseOrderReturnLookupHandler: purchaseOrderReturnLookupHandler });
        let debitMemoTypeLookupHandler = new GenericAttributeLookupHandler(
            this.props.debitMemoType,
            "DebitMemo"
        );
        this.setState({ debitMemoTypeLookupHandler: debitMemoTypeLookupHandler });


    };

    onChange = (e) => {
        this.props.onChange(e);
    };
    onLineChange = (e) => {
        this.props.onLineChange(e);
    }
    rollSkuNumberOnChange = (e) => {
        this.props.rollSkuNumberOnChange(e);
    }

    addOrUpdateReturnLineChange = (e) => {
        this.props.addOrUpdateReturnLineChange(e);
    }
    clearReturnLineValues = (e) => {
        this.props.clearReturnLineValues(e);
    }


    deleteReturnLine = (e, val, line) => {
        this.props.deleteReturnLine(line)
    }


    handleLineNumberClick = (e, val, line) => {
        this.props.handleLineNumberClick(line)
    }


    mutipleReturnLines = (e) => {
        if (e.detail === 1) {
            this.props.mutipleReturnLines(e)
        }

    }

    lineColumns = () => {
        const columns = new Array();
        columns.push(
            new ColumnDefinition()
                .setDetails("Ln#", "lineNumber", true)
                .setStyleDetails("center", "", "", "wt-2", "wt-2")
                .setClickDetails(true, false, this.handleLineNumberClick, null)
        );

        columns.push(
            new ColumnDefinition()
                .setDetails(
                    this.props.is3PL ? "Item" : "FabricStyle",
                    "fabricStyleCode",
                    true
                )
                .setStyleDetails("left", "", "", "wt-3", "wt-3")
        );
        columns.push(
            new ColumnDefinition()
                .setDetails(
                    this.props.is3PL ? "ItemName" : "FabricStyleName",
                    "fabricStyleName",
                    true
                )
                .setStyleDetails("left", "", "", "wt-3", "wt-3")
        );
        columns.push(
            new ColumnDefinition()
                .setDetails("Color", "colorCode", true)
                .setStyleDetails("left", "", "", "wt-3", "wt-3")
            // .setClickDetails(true, false, this.lnkCustomerModule,null )
        );
        columns.push(
            new ColumnDefinition()
                .setDetails(
                    this.props.is3PL ? "Inventory#" : "RollSKU#",
                    "rollSkuNumber",
                    true
                )
                .setStyleDetails("left", "", "", "wt-3", "wt-3")
        );
        columns.push(
            new ColumnDefinition()
                .setDetails(this.props.is3PL ? "Seq#" : "Roll#", "rollNumber", true)
                .setStyleDetails("right", "", "", "wt-3", "wt-3")
        );
        // columns.push(
        //     new ColumnDefinition()
        //         .setDetails("Bin#", "aisleInfoText", true)
        //         .setStyleDetails("left", "", "", "wt-3", "wt-3")
        // );
        // columns.push(
        //     new ColumnDefinition()
        //         .setDetails("Transfer Qty#", "transferQuantity", true)
        //         .setStyleDetails("right", "", "", "wt-3", "wt-3")
        // );
        columns.push(
            new ColumnDefinition()
                .setDetails("UOM#", "uomCode", true)
                .setStyleDetails("left", "", "", "wt-3", "wt-3")
        );

        columns.push(
            new ColumnDefinition()
                .setDetails("PO#", "purchaseOrderNumber", true)
                .setStyleDetails("left", "", "", "wt-3", "wt-3")
        );
        columns.push(
            new ColumnDefinition()
                .setDetails("PR#", "purchaseOrderReceiptNumber", true)
                .setStyleDetails("left", "", "", "wt-3", "wt-3")
        );

        columns.push(
            new ColumnDefinition()
                .setDetails("ReturnQty#", "lineTotalReturnQuantity", true, true)
                .setStyleDetails("right", "", "", "wt-3", "wt-3")
        );


        columns.push(
            new ColumnDefinition()
                .setDetails("isUpdateInventory", "isUpdateInventory", true)
                .setStyleDetails("left", "", "", "wt-2", "wt-2")
                .setInputDetails(
                    false,
                    false,
                    true,
                    null,
                    // this.closeOutCheck,
                    null
                )
                .setDisabled(true)
        )

        columns.push(
            new ColumnDefinition()
                .setDetails("", <DeleteIcon />, false)
                .setStyleDetails("", "", "", "wt-2", "wt-2")

                .setClickDetails(false, true, this.deleteReturnLine, <DeleteIcon />)
        );

        return columns;
    };
    render() {
        let debitMemoDataBean = this.props.debitMemoDataBean;
        let isDisableFields = this.props.isDisableFields
        let returnLines = []
        if (!isEmptyArray(debitMemoDataBean.returnLines)) {
            returnLines = debitMemoDataBean.returnLines;
        }
        let transferLines = [];
        let debitMemoReturnLineData = this.props.debitMemoReturnLineData;
        let is3PL = this.props.is3PL;
        return (
            <div>
                <div className="header_div">
                    <Row>
                        <Col className="so-align-items-left" sm="1">
                            <FormLabel>Date</FormLabel>
                        </Col>
                        <Col sm="2">
                            <DatePickerComponent_adv
                                name="createdDate"
                                value={debitMemoDataBean.createdDate}
                                onChange={this.onChange}
                                disabled={isDisableFields}
                                isMandatory={true}
                            //isModifyView={isModify}
                            />
                        </Col>
                        <Col className="so-align-items-left" sm="1">
                            <FormLabel className="header_labels">VendorCode</FormLabel>{" "}
                        </Col>
                        <Col sm="2">
                            <InputTextbox
                                //  ref={this.vendorCodeRef}
                                onChange={this.props.vendorCodeOnChange}
                                disabled={isDisableFields}
                                name="vendorCode"
                                placeholder="VendorCode"
                                value={debitMemoDataBean.vendorCode}
                                lookupRequired={true}
                                lookupHandler={this.state.vendorLookupHandler}
                                enterKeyEventHandler={this.props.vendorCodeEnterKeyEventHandler}
                                autoCompleteListData={
                                    this.props.vendorPageListForAutoCompleteList
                                }
                                enableAutoCompleteTextBox={true}
                                displayAutoCompleteList={this.props.displayVendorAutoCompleteList}
                                showAutoCompleteList={this.props.isShowAutoCompleteVendorList}
                                isMandatory={true}
                            ></InputTextbox>
                        </Col>

                        <Col sm="3">
                            <InputTextbox
                                onChange={this.onChange}
                                disabled={true}
                                name="vendorName"
                                placeholder="VendorName"
                                value={debitMemoDataBean.vendorName}
                            ></InputTextbox>
                        </Col>


                        <Col className="so-align-items-left" sm="1">
                            <FormLabel >
                                DebitMemoType
                            </FormLabel>{" "}
                        </Col>
                        <Col sm="2">
                            <InputTextbox
                                onChange={this.props.onDebitMemoTypeChange}
                                name="debitMemoType"
                                //   ref={this.purchaseRef}
                                value={debitMemoDataBean.debitMemoType}
                                //    lookupRequired={true}
                                lookupRequired={true}
                                lookupHandler={this.state.debitMemoTypeLookupHandler}
                                showCriteriaDialog={true}
                                enterKeyEventHandler={this.props.debitMemoTypeEnterKeyEvent}
                                autoCompleteListData={
                                    this.props.debitMemoTypePageListForAutoCompleteList
                                }
                                enableAutoCompleteTextBox={true}
                                displayAutoCompleteList={this.props.displayAutoCompleteDebitMemoTypeList}
                                showAutoCompleteList={this.props.showAutoCompleteDebitMemoTypeList}
                                disabled={isDisableFields}
                                //disabled={!this.props.isShowPOLookup}
                                isMandatory={true}
                            />
                        </Col>


                    </Row>
                    <Row>
                        <Col className="so-align-items-left" sm="1">
                            <FormLabel >
                                Purcahse Order#
                            </FormLabel>{" "}
                        </Col>
                        <Col sm="2">
                            <InputTextbox
                                onChange={this.props.purchaseOrderOnChange}
                                name="purchaseOrderNumber"
                                //   ref={this.purchaseRef}
                                value={debitMemoDataBean.purchaseOrderNumber}
                                //    lookupRequired={true}
                                lookupRequired={this.props.isShowPOLookup}
                                lookupHandler={this.props.purchaseorderLookupHandler}
                                showCriteriaDialog={true}
                                enterKeyEventHandler={this.props.poEnterKeyEventHandler}
                                autoCompleteListData={
                                    this.props.poPageListForAutoCompleteList
                                }
                                enableAutoCompleteTextBox={true}
                                displayAutoCompleteList={this.props.displayPoAutoCompleteList}
                                showAutoCompleteList={this.props.isShowAutoCompletePoList}
                                // disabled={isDisableFields}
                                disabled={!this.props.isShowPOLookup}
                                isMandatory={true}
                            />
                        </Col>
                        <Col className="so-align-items-left" sm="1">
                            <FormLabel header_labels_1>
                                DebitMemo Amount
                            </FormLabel>{" "}
                        </Col>
                        <Col sm="2">
                            <NumberFormatInputbox
                                className="text-end"
                                onChange={this.onChange}
                                name="debitMemoAmount"
                                placeholder="debitMemoAmount"
                                value={debitMemoDataBean.debitMemoAmount}
                                disabled={isDisableFields}
                                decimalScale={2}
                                isMandatory={true}
                            />
                        </Col>
                        <Col className="so-align-items-left" sm="1">
                            <FormLabel header_labels_1>
                                Applied Amount
                            </FormLabel>{" "}
                        </Col>
                        <Col sm="2">
                            <NumberFormatInputbox
                                className="text-end"
                                onChange={this.onChange}
                                name="appliedAmount"
                                placeholder="appliedAmount"
                                value={debitMemoDataBean.appliedAmount}
                                disabled={true}
                                decimalScale={2}

                            />
                        </Col>
                        <Col className="so-align-items-left" sm="1">
                            <FormLabel header_labels_1>
                                Open Amount
                            </FormLabel>{" "}
                        </Col>
                        <Col sm="2">
                            <NumberFormatInputbox
                                className="text-end"
                                onChange={this.onChange}
                                name="openAmount"
                                placeholder="openAmount"
                                value={debitMemoDataBean.openAmount}
                                disabled={true}
                                decimalScale={2}

                            />
                        </Col>
                    </Row>
                    {this.props.isDebitReturnype && (
                        <Row>

                            <Col sm="1">
                                <FormLabel>UpdateInv</FormLabel>
                            </Col>
                            <Col sm="2">
                                <InputCheckbox
                                    name="isUpdateInventory"
                                    type="checkbox"
                                    checked={
                                        debitMemoDataBean.isUpdateInventory
                                    }
                                    onChange={this.onChange}
                                // disabled={isDisabledFields}
                                />
                            </Col>
                        </Row>
                    )}


                </div>
                {this.props.isDebitReturnype && (
                    <div className="header_div col-md-12 col-lg-12">


                        {this.props.isShowNodes && (
                            <BaseNodeBar
                                nodeList={this.props.returnNodeList}
                                selectedModuleKey={this.props.selectedReturnNodeKey}
                                nodeOnSelect={this.props.nodeOnReturnSelect}
                            />
                        )}
                        {/* <div>
                            <Row>
                              <Col sm="2" className="title_text_div">
                                <FormLabel className="label_head">Inv Transfer Lines</FormLabel>
                              </Col>
                              {this.props.isLoadExcelButton && (
                                <Col sm="8">
                                  <Button
                                    className="enterFocus"
                                    size="sm"
                                    id="fabric_Add_Button"
                                    onClick={(e) => this.onExcelClick(e)}
                                  >
                                    Load From Excel
                                  </Button>
                                  <input
                                    type="file"
                                    id="file-input"
                                    style={{ display: "none" }}
                                    onChange={this.uploadExcelFile}
                                    accept=".doc,.docx,application/pdf,.xlsx, .xls, .csv,.txt"
                                  />
                                  <Button
                                    className="enterFocus"
                                    id="fabric_Add_Button"
                                    size="sm"
                                    onClick={(e) => this.loadPurchaseReceipt(e)}
                                  >
                                    Load From Purchase Receipt
                                  </Button>
                                  <Button
                                    className="enterFocus"
                                    id="fabric_Add_Button"
                                    size="sm"
                                    onClick={(e) => this.loadInvAdjustment(e)}
                                  >
                                    Load From InventoryAdjustment
                                  </Button>
                                </Col>
                              )}
                            </Row>
                          </div> */}
                        <div className="div_default">
                            {/* <EditableDataGrid
                              styles={styles}
                              columnsList={this.lineColumnDefinitions()}
                              dataList={transferLines}
                            /> */}
                            <CustomTable columns={this.lineColumns()} data={returnLines} label={"RETURN LINES"} />
                        </div>
                        <div>
                            <div>
                                <Row>
                                    <Col sm="2" className="title_text_div">
                                        <FormLabel className="label_head">Return Line Detail</FormLabel>
                                    </Col>
                                    {/* {!this.props.selectedReturnNodeKey == "headerView" ? ( */}
                                    {this.props.selectedReturnNodeKey == "purchaseReceiptView" && (
                                        <Col sm="2">

                                            <Button
                                                id="fabric_Add_Button"
                                                size="sm"
                                                onClick={(e) => this.mutipleReturnLines(e)}
                                            >

                                                MultipleReturnLines
                                            </Button>
                                        </Col>
                                    )}

                                </Row>
                            </div>
                            {this.props.selectedReturnNodeKey == "headerView" ? (
                                <div className="div_default">


                                    <Row>
                                        <Col sm="1">
                                            <FormLabel>Line#</FormLabel>{" "}
                                        </Col>
                                        <Col sm="2">
                                            <InputTextbox
                                                name="lineNumber"
                                                type="text"
                                                onChange={this.onLineChange}
                                                readOnly={true}
                                                value={debitMemoReturnLineData.lineNumber}
                                                disabled={true}
                                            />
                                        </Col>
                                        <Col sm="1">
                                            <FormLabel>
                                                {this.props.is3PL ? "Inventory#" : "Roll SKU"}
                                            </FormLabel>
                                        </Col>
                                        <Col sm="2">
                                            <InputTextbox
                                                ref={this.rollSkuRef}
                                                name="rollSkuNumber"
                                                // type="Number"
                                                placeholder={
                                                    this.props.is3PL ? "Enter Inventory#" : "Enter rollSKU#"
                                                }
                                                value={debitMemoReturnLineData.rollSkuNumber}
                                                onChange={this.rollSkuNumberOnChange}
                                                // disabled={isDisabledFields}
                                                isMandatory={true}
                                            />
                                            {/* <NumberFormatInputbox
                                                      ref={this.rollSkuRef}
                                                      name={"rollSkuNumber"}
                                                      placeholder="Enter rollSkuNumber"
                                                      value={inventoryAdjustmentLineData.rollSkuNumber}
                                                      onChange={this.rollSkuNumberOnChange}
                                                      className="text-end"
                                                      disabled={isDisabledFields}
                                                    /> */}
                                        </Col>
                                        <Col className="align-fabricStyles-left" sm="1">
                                            {this.props.is3PL ? (
                                                <FormLabel>Item</FormLabel>
                                            ) : (
                                                <FormLabel>FabricStyle</FormLabel>
                                            )}
                                        </Col>
                                        <Col sm="2">
                                            <InputTextbox
                                                name="fabricStyleCode"
                                                type="text"
                                                onChange={this.onLineChange}
                                                readOnly={true}
                                                value={debitMemoReturnLineData.fabricStyleCode}
                                                disabled={true}
                                            />
                                        </Col>
                                        <Col sm="3">
                                            <InputTextbox
                                                name="fabricStyleName"
                                                type="text"
                                                value={debitMemoReturnLineData.fabricStyleName}
                                                onChange={this.rollSkuOnChange}
                                                readOnly={true}
                                                disabled={true}
                                            />
                                        </Col>
                                    </Row>
                                    <Row>
                                        <Col sm="1">
                                            <FormLabel>Color</FormLabel>
                                        </Col>
                                        <Col sm="2">
                                            <InputTextbox
                                                name="colorCode"
                                                type="text"
                                                value={debitMemoReturnLineData.colorCode}
                                                onChange={this.onLineChange}
                                                readOnly={true}
                                                disabled={true}
                                            />
                                        </Col>
                                        <Col sm="1">
                                            <FormLabel>Width</FormLabel>
                                        </Col>
                                        <Col sm="2">
                                            <InputTextbox
                                                name="widthCode"
                                                type="text"
                                                placeholder="Enter widthCode"
                                                value={debitMemoReturnLineData.widthCode}
                                                onChange={this.onLineChange}
                                                readOnly={true}
                                                disabled={true}
                                            />
                                        </Col>
                                        <Col sm="1">
                                            <FormLabel>UOM</FormLabel>
                                        </Col>
                                        <Col sm="2">
                                            <InputTextbox
                                                name="uomCode"
                                                type="text"
                                                placeholder="Enter uomCode"
                                                value={debitMemoReturnLineData.uomCode}
                                                onChange={this.onLineChange}
                                                readOnly={true}
                                                disabled={true}
                                            />
                                        </Col>
                                        {/* <Col sm="1">
                                        <FormLabel>OnHandQty</FormLabel>
                                    </Col>
                                    <Col sm="2">
                                        <NumberFormatInputbox
                                            name={"onHandQuantity"}
                                            onChange={this.onLineChange}
                                            placeholder="Enter orderQuantity"
                                            value={debitMemoReturnLineData.onHandQuantity}
                                            className="text-end"
                                            decimalScale={2}
                                            disabled={true}
                                        />
                                    </Col> */}
                                        <Col sm="1">
                                            <FormLabel>ReturnQty</FormLabel>
                                        </Col>
                                        <Col sm="2">
                                            <NumberFormatInputbox
                                                name="lineTotalReturnQuantity"
                                                type="text"
                                                className="text-end"
                                                // placeholder="Enter locationCode"
                                                value={debitMemoReturnLineData.lineTotalReturnQuantity}
                                                onChange={this.onLineChange}
                                            // readOnly={true}
                                            // disabled={true}
                                            />
                                        </Col>
                                    </Row>
                                    <Row>
                                        <Col sm="1">
                                            <FormLabel>Location</FormLabel>
                                        </Col>
                                        <Col sm="2">
                                            <InputTextbox
                                                name="locationCode"
                                                type="text"
                                                placeholder="Enter locationCode"
                                                value={debitMemoReturnLineData.locationCode}
                                                onChange={this.onLineChange}
                                                readOnly={true}
                                                disabled={true}
                                            />
                                        </Col>
                                        {/* <Col sm="1">
                                        <FormLabel>AdjustQty</FormLabel>
                                    </Col>
                                    <Col sm="2">
                                        <NumberFormatInputbox
                                            name={"quantity"}
                                            onChange={this.onLineChange}
                                            placeholder="Enter orderQuantity"
                                            value={debitMemoReturnLineData.quantity}
                                            className="text-end"
                                            decimalScale={2}
                                            // readOnly={isDisabledFields}
                                            //disabled={isDisabledFields}
                                            isMandatory={true}
                                        />
                                    </Col> */}

                                        {/* <Col sm="1">
                                        <FormLabel>Bin Location</FormLabel>
                                    </Col>
                                    <Col sm="2">
                                        <InputTextbox
                                            name="binLocation"
                                            type="text"
                                            placeholder="Enter binLocation"
                                            value={debitMemoReturnLineData.binLocation}
                                            onChange={this.onLineChange}
                                            // disabled={isDisabledFields}
                                            isMandatory={true}
                                        />
                                    </Col> */}
                                        <Col sm="1">
                                            <FormLabel>{this.props.is3PL ? "Seq#" : "Roll#"}</FormLabel>
                                        </Col>
                                        <Col sm="2">
                                            <NumberFormatInputbox
                                                name={"rollNumber"}
                                                onChange={this.onLineChange}
                                                placeholder={
                                                    this.props.is3PL ? "Enter Seq" : "Enter Roll"
                                                }
                                                value={debitMemoReturnLineData.rollNumber}
                                                className="text-end"
                                                decimalScale={0}
                                                disabled={true}
                                            />
                                        </Col>
                                        {/* <Col sm="1">
                                        <FormLabel>
                                            {this.props.is3PL ? "SKU " : "Roll SKU OnHand Qty"}
                                        </FormLabel>
                                    </Col>
                                    <Col sm="2">
                                        <NumberFormatInputbox
                                            name={"rollSkuOnHandQuantity"}
                                            onChange={this.onLineChange}
                                            placeholder="Enter cost"
                                            value={debitMemoReturnLineData.rollSkuOnHandQuantity}
                                            className="text-end"
                                            decimalScale={2}
                                            disabled={true}
                                        />
                                    </Col> */}
                                        {/* <Col sm="1">
                                        <FormLabel>VENDOR LOT</FormLabel>
                                    </Col>
                                    <Col sm="2">
                                        <InputTextbox
                                            name="vendorBatchNumber"
                                            type="text"
                                            placeholder="Enter VENDOR LOT"
                                            value={debitMemoReturnLineData.vendorBatchNumber}
                                            onChange={this.onLineChange}
                                            //  disabled={isDisabledFields}
                                            isMandatory={true}
                                        />
                                    </Col> */}
                                        {!is3PL ? (
                                            <>
                                                <Col sm="1">
                                                    <FormLabel>Box</FormLabel>
                                                </Col>
                                                <Col sm="2">
                                                    <InputTextbox
                                                        name="boxNumber"
                                                        type="text"
                                                        placeholder="Enter boxNumber"
                                                        value={debitMemoReturnLineData.boxNumber}
                                                        onChange={this.onLineChange}
                                                    //disabled={isDisabledFields}
                                                    />
                                                </Col>
                                            </>
                                        ) : null}


                                        {this.props.isDebitReturnype && (


                                            <Col sm="1">
                                                <FormLabel>UpdateInv</FormLabel>
                                            </Col>
                                        )}
                                        {this.props.isDebitReturnype && (
                                            <Col sm="1">
                                                <InputCheckbox
                                                    name="isUpdateInventory"
                                                    type="checkbox"
                                                    checked={
                                                        debitMemoReturnLineData.isUpdateInventory
                                                    }
                                                    onChange={this.onLineChange}
                                                // disabled={isDisabledFields}
                                                />
                                            </Col>

                                        )}
                                    </Row>

                                    {/* <Row>
                                    <Col sm="1">
                                        <FormLabel>Line#</FormLabel>{" "}
                                    </Col>
                                    <Col sm="2">
                                        <InputTextbox
                                            name="lineNumber"
                                            type="text"
                                            onChange={this.onLineChange}
                                            readOnly={true}
                                            value={debitMemoReturnLineData.lineNumber}
                                            disabled={true}
                                        />
                                    </Col>
                                    <Col sm="1">
                                        {this.props.is3PL ? (
                                            <FormLabel>Item</FormLabel>
                                        ) : (
                                            <FormLabel>FabricSTyle</FormLabel>
                                        )}
                                    </Col>
                                    <Col sm="2">
                                        <InputTextbox
                                            onChange={this.props.fabricCodeOnChange}
                                            ref={this.fabricStyleCodeRef}
                                            name="fabricStyleCode"
                                            value={debitMemoReturnLineData.fabricStyleCode}
                                            lookupRequired={true}
                                            lookupHandler={this.state.fabricLookupHandler}
                                            enterKeyEventHandler={this.props.fabricEnterKeyEventHandler}
                                            autoCompleteListData={
                                                this.props.fabricPageListForAutoCompleteList
                                            }
                                            enableAutoCompleteTextBox={true}
                                            displayAutoCompleteList={this.props.displayAutoCompleteFabricList}
                                            showAutoCompleteList={
                                                this.props.showAutoCompleteFabricList
                                            }
                                            // readOnly={isDisabledFields}
                                            // disabled={isDisabledFields}
                                            isMandatory={true}
                                        ></InputTextbox>
                                    </Col>
                                    <Col sm="3">
                                        <InputTextbox
                                            name="fabricStyleName"
                                            type="text"
                                            value={debitMemoReturnLineData.fabricStyleName}
                                            onChange={this.onLineChange}
                                            readOnly={true}
                                        />
                                    </Col>
                                    <Col sm="1">
                                        <FormLabel>Color</FormLabel>
                                    </Col>
                                    <Col sm="2">
                                        <InputTextbox
                                            onChange={this.props.onFabricColourCodeChange}
                                            name="colorCode"
                                            placeholder="color"
                                            value={debitMemoReturnLineData.colorCode}
                                            lookupRequired={this.props.isShowColorLookup}
                                            lookupHandler={this.props.colorLookupHandler}
                                            enterKeyEventHandler={this.props.fabricColourEnterKeyEventHandler}
                                            autoCompleteListData={
                                                this.props.fabricColourPageListForAutoCompleteList
                                            }
                                            enableAutoCompleteTextBox={true}
                                            displayAutoCompleteList={this.props.displayAutoCompleteFabricColorList}
                                            showAutoCompleteList={this.props.showAutoCompleteFabricColorList}
                                            disabled={!this.props.isShowColorLookup}
                                            isMandatory={true}
                                        />
                                    </Col>
                                </Row> */}

                                    <div>
                                        <Button
                                            id="fabric_Add_Button"
                                            className="enterFocus"
                                            size="sm1"
                                            onClick={(e) => this.addOrUpdateReturnLineChange(e)}
                                        >
                                            Add/Update
                                        </Button>
                                        <Button
                                            id="fabric_Add_Button"
                                            className="enterFocus"
                                            size="sm1"
                                            onClick={(e) => this.clearReturnLineValues(e)}
                                        >
                                            Clear
                                        </Button>
                                    </div>

                                </div>
                            ) : (

                                <div className="div_default">


                                    <Row>
                                        <Col sm="1">
                                            <FormLabel>Line#</FormLabel>{" "}
                                        </Col>
                                        <Col sm="2">
                                            <InputTextbox
                                                name="lineNumber"
                                                type="text"
                                                onChange={this.onLineChange}
                                                readOnly={true}
                                                value={debitMemoReturnLineData.lineNumber}
                                                disabled={true}
                                            />
                                        </Col>
                                        <Col sm="1">
                                            <FormLabel>Purchase#</FormLabel>{" "}
                                        </Col>
                                        <Col sm="2">
                                            <InputTextbox
                                                onChange={this.props.purchaseOrderReturnOnChange}
                                                name="purchaseOrderNumber"
                                                // ref={this.purchaseRef}
                                                value={debitMemoReturnLineData.purchaseOrderNumber}
                                                lookupRequired={true}
                                                lookupHandler={this.props.purchaseorderLookupHandler}
                                                showCriteriaDialog={true}
                                                enterKeyEventHandler={this.props.poReturnEnterKeyEventHandler}
                                                autoCompleteListData={
                                                    this.props.poPageListForReturnAutoCompleteList
                                                }
                                                enableAutoCompleteTextBox={true}
                                                displayAutoCompleteList={this.props.displayPoAutoCompleteReturnList}
                                                showAutoCompleteList={this.props.isShowAutoCompleteReturnPoList}
                                                // disabled={!this.state.isShowPOLookup}
                                                //isMandatory={true}
                                                isMandatory={true}
                                            />
                                        </Col>
                                        <Col sm="1">
                                            <FormLabel>PurchaseReceipt#</FormLabel>{" "}
                                        </Col>
                                        <Col sm="2">
                                            <InputTextbox
                                                onChange={this.props.onPurchaseReceiptChange}
                                                //  ref={this.receiptCodeRef}
                                                name="purchaseOrderReceiptNumber"
                                                placeholder="purchaseOrderReceiptNumber"
                                                value={
                                                    debitMemoReturnLineData.purchaseOrderReceiptNumber
                                                }
                                                lookupRequired={this.props.isShowPurchaseReceiptLookup}
                                                //lookupRequired={true}
                                                lookupHandler={this.props.purchaseReceiptLookupHandler}
                                                showCriteriaDialog={true}
                                                enterKeyEventHandler={
                                                    this.props.purchaseReceiptEnterKeyEventHandler
                                                }
                                                autoCompleteListData={
                                                    this.props.purchaseReceiptPageListForAutoCompleteList
                                                }
                                                enableAutoCompleteTextBox={true}
                                                displayAutoCompleteList={
                                                    this.props.displayAutoCompletepurchaseReceiptList
                                                }
                                                showAutoCompleteList={
                                                    this.props.showAutoCompletepurchaseReceiptList
                                                }
                                                //   disabled={isDisabledFields}
                                                isMandatory={true}

                                            />
                                        </Col>
                                        <Col sm="1">
                                            <FormLabel>
                                                {this.props.is3PL ? "Inventory#" : "Roll SKU"}
                                            </FormLabel>
                                        </Col>
                                        <Col sm="2">
                                            <InputTextbox
                                                // ref={this.rollSkuRef}
                                                // name="rollSkuNumber"
                                                // // type="Number"
                                                // placeholder={
                                                //     this.props.is3PL ? "Enter Inventory#" : "Enter rollSKU#"
                                                // }
                                                // value={debitMemoReturnLineData.rollSkuNumber}
                                                // onChange={this.rollSkuNumberOnChange}
                                                // // disabled={isDisabledFields}
                                                // isMandatory={true}

                                                name={"rollSkuNumber"}
                                                // onChange={this.onLineChange}
                                                placeholder={
                                                    this.props.is3PL ? "Enter Seq" : "Enter Roll"
                                                }
                                                // value={debitMemoReturnLineData.rollNumber}
                                                // className="text-end"
                                                // decimalScale={0}
                                                // disabled={true}

                                                onChange={this.props.onRollSkuChange}
                                                // ref={this.documentTypeRef}

                                                value={debitMemoReturnLineData.rollSkuNumber}
                                                lookupRequired={true}
                                                lookupHandler={this.props.rollSkuLookupHandler}
                                                enterKeyEventHandler={this.props.rollSKuEnterKeyEventHandler}
                                                autoCompleteListData={
                                                    this.props.rollSkuPageListForAutoCompleteList
                                                }
                                                enableAutoCompleteTextBox={true}
                                                displayAutoCompleteList={this.props.displayAutoCompleteRollSkuList}
                                                showAutoCompleteList={this.props.isShowAutoRollSKutList}
                                            />

                                        </Col>

                                    </Row>
                                    <Row>

                                        <Col className="align-fabricStyles-left" sm="1">
                                            {this.props.is3PL ? (
                                                <FormLabel>Item</FormLabel>
                                            ) : (
                                                <FormLabel>FabricStyle</FormLabel>
                                            )}
                                        </Col>
                                        <Col sm="2">
                                            <InputTextbox
                                                name="fabricStyleCode"
                                                type="text"
                                                onChange={this.onLineChange}
                                                readOnly={true}
                                                value={debitMemoReturnLineData.fabricStyleCode}
                                                disabled={true}
                                            />
                                        </Col>
                                        <Col sm="3">
                                            <InputTextbox
                                                name="fabricStyleName"
                                                type="text"
                                                value={debitMemoReturnLineData.fabricStyleName}
                                                onChange={this.rollSkuOnChange}
                                                readOnly={true}
                                                disabled={true}
                                            />
                                        </Col>
                                        <Col sm="1">
                                            <FormLabel>Color</FormLabel>
                                        </Col>
                                        <Col sm="2">
                                            <InputTextbox
                                                name="colorCode"
                                                type="text"
                                                value={debitMemoReturnLineData.colorCode}
                                                onChange={this.onLineChange}
                                                readOnly={true}
                                                disabled={true}
                                            />
                                        </Col>
                                        <Col sm="1">
                                            <FormLabel>Width</FormLabel>
                                        </Col>
                                        <Col sm="2">
                                            <InputTextbox
                                                name="widthCode"
                                                type="text"
                                                placeholder="Enter widthCode"
                                                value={debitMemoReturnLineData.widthCode}
                                                onChange={this.onLineChange}
                                                readOnly={true}
                                                disabled={true}
                                            />
                                        </Col>

                                    </Row>
                                    <Row>

                                        <Col sm="1">
                                            <FormLabel>UOM</FormLabel>
                                        </Col>
                                        <Col sm="2">
                                            <InputTextbox
                                                name="uomCode"
                                                type="text"
                                                placeholder="Enter uomCode"
                                                value={debitMemoReturnLineData.uomCode}
                                                onChange={this.onLineChange}
                                                readOnly={true}
                                                disabled={true}
                                            />
                                        </Col>

                                        <Col sm="1">
                                            <FormLabel>ReturnQty</FormLabel>
                                        </Col>
                                        <Col sm="2">
                                            <NumberFormatInputbox
                                                name="lineTotalReturnQuantity"
                                                type="text"
                                                className="text-end"
                                                // placeholder="Enter locationCode"
                                                value={debitMemoReturnLineData.lineTotalReturnQuantity}
                                                onChange={this.onLineChange}
                                                isMandatory={true}
                                            // readOnly={true}
                                            // disabled={true}
                                            />
                                        </Col>
                                        <Col sm="1">
                                            <FormLabel>Location</FormLabel>
                                        </Col>
                                        <Col sm="2">
                                            <InputTextbox
                                                name="locationCode"
                                                type="text"
                                                placeholder="Enter locationCode"
                                                value={debitMemoReturnLineData.locationCode}
                                                onChange={this.onLineChange}
                                                readOnly={true}
                                                disabled={true}
                                            />
                                        </Col>

                                        <Col sm="1">
                                            <FormLabel>{this.props.is3PL ? "Seq#" : "Roll#"}</FormLabel>
                                        </Col>
                                        <Col sm="2">
                                            <NumberFormatInputbox
                                                name={"rollNumber"}
                                                onChange={this.onLineChange}
                                                placeholder={
                                                    this.props.is3PL ? "Enter Seq" : "Enter Roll"
                                                }
                                                value={debitMemoReturnLineData.rollNumber}
                                                className="text-end"
                                                decimalScale={0}
                                                disabled={true}
                                            />
                                        </Col>

                                        {!is3PL ? (
                                            <>
                                                <Col sm="1">
                                                    <FormLabel>Box</FormLabel>
                                                </Col>
                                                <Col sm="2">
                                                    <InputTextbox
                                                        name="boxNumber"
                                                        type="text"
                                                        placeholder="Enter boxNumber"
                                                        value={debitMemoReturnLineData.boxNumber}
                                                        onChange={this.onLineChange}
                                                    //disabled={isDisabledFields}
                                                    />
                                                </Col>
                                            </>
                                        ) : null}


                                        {this.props.isDebitReturnype && (


                                            <Col sm="1">
                                                <FormLabel>UpdateInv</FormLabel>
                                            </Col>
                                        )}
                                        {this.props.isDebitReturnype && (
                                            <Col sm="1">
                                                <InputCheckbox
                                                    name="isUpdateInventory"
                                                    type="checkbox"
                                                    checked={
                                                        debitMemoReturnLineData.isUpdateInventory
                                                    }
                                                    onChange={this.onLineChange}
                                                // disabled={isDisabledFields}
                                                />
                                            </Col>

                                        )}
                                    </Row>


                                    <div>
                                        <Button
                                            id="fabric_Add_Button"
                                            className="enterFocus"
                                            size="sm1"
                                            onClick={(e) => this.addOrUpdateReturnLineChange(e)}
                                        >
                                            Add/Update
                                        </Button>
                                        <Button
                                            id="fabric_Add_Button"
                                            className="enterFocus"
                                            size="sm1"
                                            onClick={(e) => this.clearReturnLineValues(e)}
                                        >
                                            Clear
                                        </Button>
                                    </div>

                                </div>
                            )}
                        </div>
                    </div>
                )}
            </div>

        );
    }
}

class DebitMemoListForm extends React.Component {
    static contextType = AppContext;
    constructor(props) {
        super(props);
        this.state = {
            // criteria: new PurchaseOrderSearchCriteria(),
            pageList: this.props.pageList,
        };
        this.searchRef = React.createRef();
    }
    componentDidMount() {
        const { appData } = this.context;
        this.companyCode = appData.companyCode;
        //  this.initLookupHandlers();
    }
    // componentDidMount() {
    //   if (this.searchRef.current != null) {
    //     this.searchRef.current.focus();
    //   }
    // }
    searchOnChange = (e) => {
        this.props.searchOnChange(e);
    };
    filterDebitMemo = (e) => {
        if (e.detail == 1) this.props.filterDebitMemo();
    };
    resetDebitMemo = (e) => {
        let criteria = this.props.debitMemoSearchCriteria;
        if (e.detail == 1) this.props.resetDebitMemo(criteria);
    };
    loadFirst = (e) => {
        if (e.detail == 1) this.props.loadFirst();
    };
    loadNext = (e) => {
        if (e.detail == 1) this.props.loadNext();
    };
    loadPrevious = (e) => {
        if (e.detail == 1) this.props.loadPrevious();
    };
    loadLast = (e) => {
        if (e.detail == 1) this.props.loadLast();
    };
    editDebitMemo = (e, val, rowData) => {
        if (e.detail == 1) this.props.editDebitMemo(val);
    };
    //   onKeyDown = (e) => {
    //     if (e.keyCode == 13) {
    //       this.props.filterCpm();
    //     }
    //   };
    debitMemoListColumns = () => {
        const columns = new Array();
        columns.push(
            new ColumnDefinition()
                .setDetails("DebitMemo", "code", true)
                .setStyleDetails("left", "", "", "wt-3", "wt-3")
                .setClickDetails(true, false, this.editDebitMemo, null)
        );
        columns.push(
            new ColumnDefinition()
                .setDetails("Status", "debitMemoStatus", true)
                .setStyleDetails("left", "", "", "wt-3", "wt-3")
                .setStatusDetails(true, this.getCaption)
        );
        columns.push(
            new ColumnDefinition()
                .setDetails("Vendor", "vendorCode", true)
                .setStyleDetails("left", "", "", "wt-3", "wt-3")
        );
        columns.push(
            new ColumnDefinition()
                .setDetails("VendorName", "vendorName", true)
                .setStyleDetails("left", "", "", "wt-3", "wt-3")
        );
        columns.push(
            new ColumnDefinition()
                .setDetails("CreatedDate", "createdDate", true, false, true)
                .setStyleDetails("left", "", "", "wt-3", "wt-3")
        );
        columns.push(
            new ColumnDefinition()
                .setDetails("Type", "debitMemoType", true)
                .setStyleDetails("left", "", "", "wt-3", "wt-3")
        );

        columns.push(
            new ColumnDefinition()
                .setDetails("PO#", "purchaseOrderNumber", true)
                .setStyleDetails("left", "", "", "wt-3", "wt-3")
        );

        columns.push(
            new ColumnDefinition()
                .setDetails("Amount", "debitMemoAmount", true, true)
                .setStyleDetails("right", "", "", "wt-3", "wt-3")
        );
        columns.push(
            new ColumnDefinition()
                .setDetails("AppliedAmount", "appliedAmount", true, true)
                .setStyleDetails("right", "", "", "wt-3", "wt-3")
        );
        columns.push(
            new ColumnDefinition()
                .setDetails("OpenAmount", "openAmount", true, true)
                .setStyleDetails("right", "", "", "wt-3", "wt-3")
        );

        return columns;
    }
    getCaption = (status) => {
        return ModuleUtils.getDebitMemoStatusCaption(status);
    };
    render() {
        let pageList = this.props.pageList;
        let totalPages = 0;
        if (!isEmpty(pageList)) {
            let pageSize = pageList.pageSize;
            let totalCount = pageList.totalCount;
            totalPages = totalCount / pageSize;
            totalPages += totalCount % pageSize == 0 ? 0 : 1;
        }
        let debitMemoList = this.props.debitMemoList;
        let criteria = this.props.debitMemoSearchCriteria;
        return (
            <div>
                <div className="secondary_module_header">
                    <div className="mdle-criteria-wrap">

                        <div className="">
                            <FormLabel className="criteria-labl">Status</FormLabel>
                        </div>
                        <div className="criteria-val">
                            <FormControl
                                as="select"
                                custom
                                onChange={this.searchOnChange}
                                name="debitMemoStatus"
                                value={criteria.debitMemoStatus}
                            >
                                <option value={""}>All</option>
                                <option value={"O"}>Open</option>
                                <option value={"A"}>Approved</option>
                                <option value={"P"}>PartiallyClosed</option>
                                <option value={"C"}>PartiallyUsedApproved</option>
                                <option value={"F"}>Finished</option>
                                <option value={"X"}>Cancel</option>
                            </FormControl>
                        </div>
                        <FormLabel className="secondary_module_search_color">
                            Search
                        </FormLabel>
                        <span className="secondary_module_header_title_2">
                            <InputTextbox
                                ref={this.searchRef}
                                name="debitMemoNumber"
                                type="text"
                                value={criteria.debitMemoNumber}
                                placeholder="Enter Value to Filter.."
                                onChange={this.searchOnChange}
                                onKeyDown={this.onKeyDown}
                            />
                            <Button onClick={(e) => this.filterDebitMemo(e)}>
                                Filter
                            </Button>
                            <Button onClick={(e) => this.resetDebitMemo(e)}>
                                Reset
                            </Button>
                        </span>
                    </div>
                    <div className="module_header_secondary_buttons">
                        <span>
                            PAGE - {pageList.currentPage} OF {parseInt(totalPages)}
                        </span>
                        <Button
                            size="sm"
                            className="secondary_header_buttons"
                            onClick={(e) => this.loadFirst(e)}
                        >
                            First
                        </Button>
                        <Button
                            size="sm"
                            className="secondary_header_buttons"
                            onClick={(e) => this.loadPrevious(e)}
                        >
                            Previous
                        </Button>
                        <Button
                            size="sm"
                            className="secondary_header_buttons"
                            onClick={(e) => this.loadNext(e)}
                        >
                            Next
                        </Button>
                        <Button
                            size="sm"
                            className="secondary_header_buttons"
                            onClick={(e) => this.loadLast(e)}
                        >
                            Last
                        </Button>
                    </div>
                </div>
                <div className="mt-3">
                    <CustomTable
                        data={debitMemoList}
                        columns={this.debitMemoListColumns()}
                         enableHighlight={true}
                    />
                </div>
            </div>
        );
    }
}
class DebitMemoAppliedForm extends React.Component {
    static contextType = AppContext;
    constructor(props) {
        super(props);
        this.state = {

        }

    }
    componentDidMount() {
        const { appData } = this.context;
        this.companyCode = appData.companyCode;

    }
    render() {
        return (
            <div>
                APPLIED FORM

            </div>
        );
    }
}

class DebitMemoHistoryForm extends React.Component {
    static contextType = AppContext;
    constructor(props) {
        super(props);
        this.state = {

        }

    }
    componentDidMount() {
        //
    }
    statusTrackColumn = () => {
        const columns = new Array();

        columns.push(
            new ColumnDefinition()
                .setDetails("Date", "createdDate", true, false, true)
                .setStyleDetails("left", "", "", "wt-5", "wt-5")
        );

        columns.push(
            new ColumnDefinition()
                .setDetails("TotalDebitAmount", "totalDebitAmount", true, true)
                .setStyleDetails("right", "", "", "wt-5", "wt-5")
        );
        columns.push(
            new ColumnDefinition()
                .setDetails("Status", "currentStatus", true,)
                .setStyleDetails("left", "", "", "wt-5", "wt-5")
                .setStatusDetails(true, this.status)

        );
        columns.push(
            new ColumnDefinition()
                .setDetails("PreviousStatus", "previousStatus", true,)
                .setStyleDetails("left", "", "", "wt-5", "wt-5")
                .setStatusDetails(true, this.prevStatus)
        );
        columns.push(
            new ColumnDefinition()
                .setDetails("Track", "trackNumber", true,)
                .setStyleDetails("left", "", "", "wt-5", "wt-5")
        );
        columns.push(
            new ColumnDefinition()
                .setDetails("TrackType", "trackType", true,)
                .setStyleDetails("left", "", "", "wt-5", "wt-5")
                .setStatusDetails(true, this.trackStatus)
        );
        columns.push(
            new ColumnDefinition()
                .setDetails("Remarks", "remarks", true,)
                .setStyleDetails("left", "", "", "wt-5", "wt-5")
        );
        columns.push(
            new ColumnDefinition()
                .setDetails("DoneBy", "createdBy", true,)
                .setStyleDetails("left", "", "", "wt-5", "wt-5")
        );
        return columns;
    };
    status = (currentStatus) => {
        return ModuleUtils.getDebitMemoStatusCaption(currentStatus);
    };

    prevStatus = (previousStatus) => {
        return ModuleUtils.getDebitMemoStatusCaption(previousStatus);
    };
    trackStatus = (status) => {
        return ModuleUtils.getDebitMemoTrackStatusCaption(status);
    }
    render() {
        let debitMemoDataBean = this.props.debitMemoDataBean;
        let statusTracks = new Array();
        statusTracks = debitMemoDataBean.statusTracks;
        return (
            <div>
                <div className="header_div">
                    <div>
                        <div className="div_Custom_1">
                            <CustomTable
                                data={statusTracks}
                                columns={this.statusTrackColumn()}
                                label={"Status Tracks Table"}
                            />
                        </div>
                    </div>
                </div>
            </div>
        );
    }
}
class DebitMemoMaintenanceModule extends React.Component {
    constructor(props) {
        super(props);
    }
    render() {
        return (
            <div id="moduleContainer" className="module_container">
                <div className="App">
                    <DebitMemo {...this.props} name="" />
                    <br />
                </div>
            </div>
        );
    }
}

export default DebitMemoMaintenanceModule;